import { put, call, all, takeEvery, delay, select,take } from "redux-saga/effects";
import commonActions from "../common/actions";
import candidatesActions from "./actions";
import axios from "axios";
// import { API_URL } from "../../utils/constants";
import masterActions from "../master/action";
import authActions from "../auth/actions";
import Cookies from "js-cookie";
import { calculateDaysDifference, formatDate } from "../../utils/validations";
import {
  EncryptFunction,
  EncryptObjectFunction,
} from "../../utils/cryptoFunction";
import { ExternalError, InternalError } from "../../common/ErrorMessage";
import {
  handleDecodeJSON,
  handleEncodeJson,
} from "../../utils/encodeDecodeJson";
import { downloadBase64,downloadFile } from "../../utils/downloadBase64";
import { external } from "jszip";
import { getCacheWithExpiry, setCacheWithExpiry, cacheTTL } from "../../utils/CacheHelper";
import { collectDeviceInfo } from "../../utils/deviceInfo";

const candidatesSaga = function* () {
  yield all([
    yield takeEvery(
      candidatesActions.PROFILE_PERSONAL_DETAILS_CREATION,
      profilePersonalDetailsCreation
    ),
    yield takeEvery(
      candidatesActions.GET_PROFILE_PERSONAL_DETAILS,
      getProfilePersonalDetails
    ),
    yield takeEvery(
      candidatesActions.PROFILE_ADDRESS_DETAILS_CREATION,
      addressPersonalDetailsCreation
    ),
    yield takeEvery(
      candidatesActions.PROFILE_CATEGORY_DETAILS_CREATION,
      categoryPersonalDetailsCreation
    ),
    yield takeEvery(
      candidatesActions.PROFILE_EDUCATION_DETAILS_CREATION,
      educationPersonalDetailsCreation
    ),
    yield takeEvery(
      candidatesActions.PROFILE_EXAM_DETAILS_CREATION,
      examPersonalDetailsCreation
    ),

    yield takeEvery(
      candidatesActions.PROFILE_CERTIFICATES_DETAILS_CREATION,
      certificatesPersonalDetailsCreation
    ),
    yield takeEvery(
      candidatesActions.PROFILE_UPLOADS_DETAILS_CREATION,
      uploadsPersonalDetailsCreation
    ),
    yield takeEvery(
      candidatesActions.GET_ADDRESS_PERSONAL_DETAILS,
      getAddressPersonalDetails
    ),
    yield takeEvery(
      candidatesActions.GET_CATEGORY_PERSONAL_DETAILS,
      getCategoryPersonalDetails
    ),
    yield takeEvery(
      candidatesActions.GET_EDUCATION_PERSONAL_DETAILS,
      getEducationPersonalDetails
    ),
    yield takeEvery(
      candidatesActions.GET_EXAM_PERSONAL_DETAILS,
      getExamPersonalDetails
    ),
    yield takeEvery(
      candidatesActions.GET_CERTIFICATE_PERSONAL_DETAILS,
      getCertificatePersonalDetails
    ),
        yield takeEvery(
      candidatesActions.GET_IS_INSTRUCTION_READ,
      handleGetInstructionRead
    ),
    yield takeEvery(
      candidatesActions.PROFILE_PERSONAL_DETAILS_DRAFT_CREATION,
      personalDetailsDraftCreation
    ),
    yield takeEvery(
      candidatesActions.PROFILE_ADDRESS_DETAILS_DRAFT_CREATION,
      personalAddressDetailsDraftCreation
    ),
    yield takeEvery(
      candidatesActions.PROFILE_CATEGORY_DETAILS_DRAFT_CREATION,
      personalCategoryDetailsDraftCreation
    ),
    yield takeEvery(
      candidatesActions.PROFILE_EDUCATION_DETAILS_DRAFT_CREATION,
      personalEducationDetailsDraftCreation
    ),
    yield takeEvery(
      candidatesActions.PROFILE_EXAM_DETAILS_DRAFT_CREATION,
      personalExamDetailsDraftCreation
    ),
    yield takeEvery(
      candidatesActions.IS_INSTRUCTION_READ,
      handleInstructionRead
    ),
    yield takeEvery(
      candidatesActions.PROFILE_CERTIFICATE_DETAILS_DRAFT_CREATION,
      personalCertificatesDetailsDraftCreation
    ),
    yield takeEvery(
      candidatesActions.GRIEVANCE_QUERY_CREATION,
      grievanceQueryCreation
    ),
    yield takeEvery(
      candidatesActions.GET_QUERY_STATUS_BY_CANDIDATEID,
      getQueryStatusByCandidate
    ),
    yield takeEvery(
      candidatesActions.PROFILE_OTHER_DETAILS_CREATION,
      otherDetailsCreation
    ),
    yield takeEvery(
      candidatesActions.PROFILE_OTHER_DETAILS_DRAFT_CREATION,
      otherDetailsDraftCreation
    ),
    yield takeEvery(
      candidatesActions.GET_OTHER_PERSONAL_DETAILS,
      getOtherDetails
    ),
    yield takeEvery(
      candidatesActions.PROFILE_UPLOADS_DETAILS_DRAFT_CREATION,
      uploadsDraftCreation
    ),
    yield takeEvery(
      candidatesActions.GET_UPLOAD_PERSONAL_DETAILS,
      getUploadDetails
    ),
    yield takeEvery(
      candidatesActions.GET_COURSE_UPLOAD_PERSONAL_DETAILS,
      getCourseUploadDetails
    ),
    yield takeEvery(candidatesActions.GET_PINCODE, getPincode),
    yield takeEvery(
      candidatesActions.GET_PINCODE_CORRESPONDENCE,
      getPincodeCorrespondence
    ),
    yield takeEvery(
      candidatesActions.GET_FULL_CANDIDATE_DETAILS,
      getFullCandidateDetails
    ),
    yield takeEvery(
      candidatesActions.GET_FULL_CANDIDATE_DETAIL,
      getFullCandidateDetail
    ),

    yield takeEvery(
      candidatesActions.COURSE_PERSONAL_DETAILS_CREATION,
      coursePersonaldetailsCreation
    ),
    yield takeEvery(
      candidatesActions.COURSE_ADDRESS_DETAILS_CREATION,
      courseAddressdetailsCreation
    ),
    yield takeEvery(
      candidatesActions.COURSE_RESERVATION_DETAILS_CREATION,
      courseReservationdetailsCreation
    ),
    yield takeEvery(
      candidatesActions.COURSE_ACADEMIC_DETAILS_CREATION,
      courseAcademicdetailsCreation
    ),
    yield takeEvery(
      candidatesActions.COURSE_EXAM_DETAILS_CREATION,
      courseExamdetailsCreation
    ),
    yield takeEvery(
      candidatesActions.OTBS_COURSE_EXAM_DETAILS_CREATION,
      otbsCourseExamdetailsCreation
    ),

    yield takeEvery(
      candidatesActions.OTBS_UPDATE_COURSE_EXAM_DETAILS_CREATION,
      otbsUpdateCourseExamdetailsCreation
    ),

    yield takeEvery(
      candidatesActions.GET_COURSE_REGISTRATION_DETAILS,
      getAllCourseRegistrationDetails
    ),
    yield takeEvery(
      candidatesActions.GET_COURSE_ADDRESS_DETAILS,
      getCourseAddressDetails
    ),
    yield takeEvery(candidatesActions.GET_ALL_COURSE_LIST, getAllCourse),
    yield takeEvery(candidatesActions.GET_SCRIBE1_PHOTO_DETAILS, getScribe1PhotoDetails),
    yield takeEvery(candidatesActions.GET_SCRIBE2_PHOTO_DETAILS, getScribe2PhotoDetails),
    yield takeEvery(candidatesActions.GET_SCRIBE1_DOC_DETAILS, getScribe1DocDetails),
    yield takeEvery(candidatesActions.GET_SCRIBE2_DOC_DETAILS, getScribe2DocDetails),
    yield takeEvery(candidatesActions.GET_SCRIBE1_QUALIFY_DOC_DETAILS, getScribe1QualifyDocDetails),
    yield takeEvery(candidatesActions.GET_SCRIBE2_QUALIFY_DOC_DETAILS, getScribe2QualifyDocDetails),
    yield takeEvery(candidatesActions.GET_COURSE_TAB, getCourseTab),
    yield takeEvery(candidatesActions.GET_MASTER_FIELDS, getMasterFields),
    yield takeEvery(candidatesActions.GET_SCRIBE_DETAILS, getScribeDetails),
    yield takeEvery(candidatesActions.REMOVE_SCRIBE_INFORMATION, removeScribeDetails),
    yield takeEvery(candidatesActions.GET_PCM_PCB_DETAILS, getPcmPcbDetails),
    // yield takeEvery(candidatesActions.GET_CANDIDATE_SCRIBE_DETAILS, getCandidateScribeDetails),
    yield takeEvery(
      candidatesActions.GET_COURSE_ACTIVE_TAB,
      getCourseRegistrationActiveTab
    ),
    yield takeEvery(
      candidatesActions.GET_COURSE_APPLICANTID,
      getCourseApplicantId
    ),
    yield takeEvery(candidatesActions.GET_COURSE_STATUS, getCourseStatus),
    yield takeEvery(candidatesActions.GET_IS_PAID, getIsPaid),
    yield takeEvery(candidatesActions.UPLOAD_SCRIBE1_PHOTO, uploadScribe1Photo),
    yield takeEvery(candidatesActions.UPLOAD_SCRIBE1_DOCUMENT, uploadScribe1Document),
    yield takeEvery(candidatesActions.UPLOAD_SCRIBE2_PHOTO, uploadScribe2Photo),
    yield takeEvery(candidatesActions.UPLOAD_SCRIBE2_DOCUMENT, uploadScribe2Document),
    yield takeEvery(candidatesActions.UPLOAD_SCRIBE1_QUALIFY_DOCUMENT, uploadScribe1QualifyDocument),
    yield takeEvery(candidatesActions.UPLOAD_SCRIBE2_QUALIFY_DOCUMENT, uploadScrib2QualifyDocument),
    yield takeEvery(
      candidatesActions.GET_PAYMENT_RECEIPT_LIST,
      getPaymentReceiptList
    ),
    yield takeEvery(candidatesActions.GET_EXAM_STATE, getExamState),
    yield takeEvery(candidatesActions.GET_EXAM_DISTRICT, getExamDistrict),
    yield takeEvery(candidatesActions.GET_EXAM_LANGUAGE, getExamLanguage),
    yield takeEvery(
      candidatesActions.GET_OTBS_VENUE_DETAILS,
      getOtbsVenueDetails
    ),
    yield takeEvery(
      candidatesActions.GET_CURRENT_VENUE_DETAILS,
      getCurrentOtbsVenueDetails
    ),
    yield takeEvery(candidatesActions.GET_VENUE_DETAILS, getVenueDetails),
    yield takeEvery(candidatesActions.GET_SEAT_AVAILIBILITY, getSeatAvailibility),
    
    yield takeEvery(
      candidatesActions.GET_FREE_VENUE_DETAILS,
      getFreecourseVenueDetails
    ),

    yield takeEvery(
      candidatesActions.GET_COURSE_FORM_DETAILS,
      getCourseFormDetails
    ),
    yield takeEvery(candidatesActions.GET_CURRENT_COURSE, getCurrentCourse),
    yield takeEvery(
      candidatesActions.COURSE_PREVIEW_UPDATION,
      updatePreviewandPaymentStatus
    ),
    yield takeEvery(candidatesActions.CREATE_PRINT_LOG, createPrintLog),
    yield takeEvery(candidatesActions.EDIT_COURSE_DETAILS, updateCourseDetails),
    // yield takeEvery(candidatesActions.EDIT_COURSE_DETAILS, getIpAddress),
    yield takeEvery(candidatesActions.DOWLOAD_BROCHURE, downloadBrochure),
    yield takeEvery(
      candidatesActions.GET_CANDIDATE_COURSE_DETAILS,
      getcourseCandidateList
    ),
    yield takeEvery(
      candidatesActions.GET_ADMIT_CARD_DOWNLOAD_DETAILS,
      getAdmitCardDownloadDetails
    ),
    yield takeEvery(candidatesActions.DOWNLOAD_ADMIT_CARD, downloadAdmitCard),
    yield takeEvery(
      candidatesActions.GET_SCORE_CARD_DOWNLOAD_DETAILS,
      getScoreCardDownloadDetails
    ),
    yield takeEvery(candidatesActions.CREATE_DOWNLOAD_LOG, createDownloadLog),
    yield takeEvery(
      candidatesActions.CREATE_SCORECARD_DOWNLOAD_LOG,
      createscoreDownloadLog
    ),

    yield takeEvery(
      candidatesActions.ADMIT_AND_SCORE_CARD_VIEW_BUTTON_CLICK,
      AdmitAndScorecardViewButtonClick
    ),
    yield takeEvery(
      candidatesActions.FREE_REGISTRATION,
      Freecourseregistration
    ),
    yield takeEvery(candidatesActions.GET_ADMITCARD_URL, GetAdmitcardUrl),
    yield takeEvery(candidatesActions.GET_BYPASS_REGISTRATION, GetBypassRegistration),
    yield takeEvery(candidatesActions.GET_AIRPAY_PAYMENT, GetAirpaypayment),
     yield takeEvery(candidatesActions.GET_TOTAL_FEE, getTotalFee),
         yield takeEvery(
      candidatesActions.GET_COURSE_PERSONAL_INFORMATION_DETAILS,
      getCoursePersonalInformationDetails
    ),

     yield takeEvery(
      candidatesActions.GET_COURSE_RESERVATION_DETAILS,
      getCourseReservationDetails
    ),

     yield takeEvery(
      candidatesActions.GET_COURSE_ACADEMIC_DETAILS,
      getCourseAcademicDetails
    ),

     yield takeEvery(
      candidatesActions.GET_COURSE_EXAMCENTER_DETAILS,
      getCourseExamCenterDetails
    ),

    yield takeEvery(
      candidatesActions.GET_COURSE_EDITINGFACILITY_DETAILS,
      getCourseEditingFacilityDetails
    ),

     yield takeEvery(
      candidatesActions.GET_COURSE_PAYMENTINFORMATION_DETAILS,
      getCoursePaymentInformationDetails
    ),

  ]);
};
const getTotalFee=function*({payload}){
   try {
        const profileSummary = yield select(
  (state) => state?.authReducer?.ProfileSummaryDetails
);  
      
     const candidateid = yield select(
    (state) => state?.authReducer?.candidateTokenDetails?.candidateid
  ) || profileSummary[0]?.candidateid;
    const { courseid} = payload;
    const Token=sessionStorage.getItem("mhet_cnd_token")
    const result = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_URL}/candidate/course/registraton/course-registration-amount/${encodeURIComponent(
          EncryptFunction(candidateid))}/${encodeURIComponent(
          EncryptFunction(courseid)
        )}}`,{
          headers: {
            authorization: `Bearer ${Token}`,
          },
        } 
      )
    );
    const decryptedData = yield call(handleDecodeJSON, {
      decodeJSON: result?.data.result,
    });
    // console.log(decryptedData,"pks")
    yield put({
      type: candidatesActions.SET_TOTAL_FEE,
      payload: result?.data?.statusCode === 200 ? decryptedData : [],
    });
    yield call(ExternalError, result)
    // yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
  }catch(err){
  yield call(InternalError, err)
  }
 
}
const GetAirpaypayment=function*({payload}){
   try {
  //    const candidateid = yield select(
  //   (state) => state?.authReducer?.candidateTokenDetails?.candidateid
  // );
    const { courseid} = payload;
    const Token=sessionStorage.getItem("mhet_cnd_token")
    const result = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_URL}/air-pay/verify-payment/${encodeURIComponent(
          EncryptFunction(courseid)
        )}}`,{
          headers: {
            authorization: `Bearer ${Token}`,
          },
        } 
      )
    );
    const decryptedData = yield call(handleDecodeJSON, {
      decodeJSON: result?.data?.result,
    });
    // console.log(decryptedData,"pks")
    yield put({
      type: candidatesActions.SET_AIRPAY_PAYMNET,
      payload: result?.data?.statusCode === 200 ? decryptedData : [],
    });
    yield call(ExternalError, result)
    yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
  }catch(err){
  yield call(InternalError, err)
  }
 
}
const GetBypassRegistration = function* ({ payload }) {
  // yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
     const candidateid = yield select(
    (state) => state?.authReducer?.candidateTokenDetails?.candidateid
  );
    const { courseid,navigate,coursename} = payload;
    const Token=sessionStorage.getItem("mhet_cnd_token")
    const result = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_URL}/candidate/course/registraton/course-status/${encodeURIComponent(
          EncryptFunction(courseid)
        )}/${encodeURIComponent(EncryptFunction(coursename))}}`,{
          headers: {
            authorization: `Bearer ${Token}`,
          },
        } 
      )
    );
    const decryptedData = yield call(handleDecodeJSON, {
      decodeJSON: result?.data?.encryptedData,
    });

      const queryParams = {
      courseid: courseid,
      coursename: coursename,
    };
    const encryptedParams = EncryptObjectFunction(queryParams);
    console.log("decryptedData.registration_status>>>>",decryptedData.registration_status)
    if(decryptedData.registration_status==="Register Now"){
       yield put({
      type: candidatesActions.SET_BYPASS_REGISTRATION,
      payload: result?.data?.statusCode === 200 ? decryptedData.registration_status : [],
    });
      navigate(`/${sessionStorage.getItem( "mhet_cnd_project")}/course-registration?page=personalinformation&courseid=${EncryptFunction(courseid)}&coursename=${encodeURIComponent(coursename)}`,
    {
      state: { allowAccess: true }, 
    })
    payload?.callback?.();
    // } else if (decryptedData.registration_status==="Edit Now"){
    } else if (decryptedData.registration_status==="Edit Now"){
       navigate(
      `/${sessionStorage.getItem(
        "mhet_cnd_project"
      )}/editing-facility?c_data=${encryptedParams}`
    );
    }else{
      yield put({
      type: candidatesActions.SET_BYPASS_REGISTRATION,
      payload: result?.data?.statusCode === 200 ? decryptedData.registration_status : [],
    });
    payload?.callback?.();
      // navigate( `/${sessionStorage.getItem("mhet_cnd_project"
      //                                 )}/registrations`,
      //                                 {
      //                                   state: {
      //                                     status:decryptedData.registration_status
      //                                   },
      //                                 }
      //                               );
    }
    // const decryptedData = yield call(handleDecodeJSON, {
    //   decodeJSON: result?.data?.encryptedData,
    // });
    // yield put({
    //   type: candidatesActions.SET_BYPASS_REGISTRATION,
    //   payload: result?.data?.statusCode === 200 ? decryptedData : [],
    // });
    yield call(ExternalError, result)
  
  } catch (err) {
    yield call(InternalError, err)



  }
  // yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};

const getcourseCandidateList = function* ({ payload }) {
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  try {
    const { courseid, candidateid } = payload;
    const result = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_URL}/master/coursemanagement/getstudentcourseCandidateList/${encodeURIComponent(
          EncryptFunction(courseid)
        )}/${encodeURIComponent(EncryptFunction(candidateid))}`
      )
    );
    const decryptedData = yield call(handleDecodeJSON, {
      decodeJSON: result?.data?.encryptedData,
    });
    yield put({
      type: candidatesActions.SET_CANDIDATE_COURSE_DETAILS,
      payload: result?.data?.statusCode === 200 ? decryptedData : [],
    });
    yield call(ExternalError, result)
    yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
  } catch (err) {
    yield call(InternalError, err)
  }
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};

// Download page details: application number, name, course. Stamping and the
// signed URL are left to downloadAdmitCard, which runs only on click.
const getAdmitCardDownloadDetails = function* ({ payload }) {
  try {
    const { courseid } = payload;
    const result = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_URL}/candidate/admitcard/details/${encodeURIComponent(
          EncryptFunction(courseid)
        )}`
      )
    );
    if (result?.data?.statusCode === 200) {
      const decryptedData = yield call(handleDecodeJSON, {
        decodeJSON: result?.data?.result,
      });
      yield put({
        type: candidatesActions.SET_ADMIT_CARD_DOWNLOAD_DETAILS,
        payload: { status: "success", data: decryptedData },
      });
      yield call(showAdmitCardAlert, "success", "Applicant Found, Fetching Admit Card Details..");
    } else {
      yield put({
        type: candidatesActions.SET_ADMIT_CARD_DOWNLOAD_DETAILS,
        payload: { status: "error", message: result?.data?.message || "No records found" },
      });
    }
  } catch (err) {
    yield put({
      type: candidatesActions.SET_ADMIT_CARD_DOWNLOAD_DETAILS,
      payload: { status: "error", message: "Unable to fetch admit card details" },
    });
    yield call(InternalError, err);
  }
};

const showAdmitCardAlert = function* (status, message) {
  yield put({
    type: commonActions.SET_ALERT,
    payload: { status, show: true, message },
  });
  yield delay(3000);
  yield put({
    type: commonActions.SET_ALERT,
    payload: { status: null, show: false, message: null },
  });
};

// Stamps and signs on the server, saves the PDF, and logs the download only
// once the file is actually in hand.
const downloadAdmitCard = function* ({ payload }) {
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  const { courseid, candidateid } = payload;
  try {
    // The API reads the candidate from the login token; this path segment is
    // only there because the route has it, so any value will do.
    const result = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_URL}/candidate/admitcard/${encodeURIComponent(
          EncryptFunction(candidateid || 0)
        )}/${encodeURIComponent(EncryptFunction(courseid))}`
      )
    );
    if (result?.data?.statusCode !== 200) {
      yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
      yield call(showAdmitCardAlert, "failed", result?.data?.message || "Unable to download admit card");
      return;
    }

    const { admitcardurl } = yield call(handleDecodeJSON, {
      decodeJSON: result?.data?.result,
    });

    const response = yield call(fetch, admitcardurl);
    if (!response.ok) {
      throw new Error(`Admit card fetch failed with status ${response.status}`);
    }
    const blob = yield call([response, response.blob]);

    const fileName = admitcardurl
      ?.split("/").pop().split("?")[0]
      ?.replace(/\.pdf\.pdf$/i, ".pdf") || "admit-card.pdf";
    const blobUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = blobUrl;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(blobUrl);

    let deviceInfo = null;
    try {
      deviceInfo = yield call(collectDeviceInfo);
    } catch (error) {
      console.error("Device info unavailable:", error);
    }
    yield call(createDownloadLog, {
      payload: { data: { candidateid, courseid, deviceInfo } },
    });
  } catch (err) {
    console.error("Admit card download failed:", err);
    yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
    yield call(showAdmitCardAlert, "failed", "Unable to download admit card. Please try again.");
    return;
  }
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};

const getScoreCardDownloadDetails = function* ({ payload }) {
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  try {
    const { courseid, candidateid } = payload;
    const result = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_URL}/candidate/scorecard/${encodeURIComponent(
          EncryptFunction(candidateid)
        )}/${encodeURIComponent(EncryptFunction(courseid))}`
      )
    );
    if (result?.data?.statusCode === 200) {
      const decryptedData = yield call(handleDecodeJSON, {
        decodeJSON: result?.data?.result,
      });
      yield put({
        type: candidatesActions.SET_SCORE_CARD_DOWNLOAD_DETAILS,
        payload: decryptedData,
      });
    } else {
      yield put({
        type: candidatesActions.SET_SCORE_CARD_DOWNLOAD_DETAILS,
        payload: null,
      });
    }
  } catch (err) {
    yield put({
      type: candidatesActions.SET_SCORE_CARD_DOWNLOAD_DETAILS,
      payload: null,
    });
    yield call(InternalError, err);
  }
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};

const getScribeDetails = function* ({ payload }) {
  // yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  try {
    const { courseid, candidateid } = payload;
    const result = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_URL}/candidate/course/registraton/scribe-details/${encodeURIComponent(
          EncryptFunction(candidateid)
        )}/${encodeURIComponent(EncryptFunction(courseid))}`
      )
    );
    // return;
    const decryptedData = yield call(handleDecodeJSON, {
      decodeJSON: result?.data?.result,
    });
    console.log(decryptedData,"decryptedddddatsaaaaa")
    if(result?.data?.statusCode === 200){
      yield put({
        type: candidatesActions.SET_SCRIBE_DETAILS,
        payload: result?.data?.statusCode === 200 ? decryptedData : [],
      });
    }
    // yield call(ExternalError, result)
    // window.location.reload()
    // Reload the page
      //  window.location.reload();
    yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
  } catch (err) {
    return;
    // yield call(InternalError, err)
  }
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};

const getPcmPcbDetails = function* ({ payload }) {
  // yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  try {
    const { candidateid } = payload;
    const result = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_URL}/candidate/course/registraton/getnooofattempts/${encodeURIComponent(
          EncryptFunction(candidateid)
        )}`
      )
    );
    const decryptedData = yield call(handleDecodeJSON, {
      decodeJSON: result?.data?.result,
    });
    if(result?.data?.statusCode === 200){
      yield put({
        type: candidatesActions.SET_PCM_PCB_DETAILS,
        payload: result?.data?.statusCode === 200 ? decryptedData : [],
      });
    }
    // yield call(ExternalError, result)
    // window.location.reload()
    // Reload the page
      //  window.location.reload();
    yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
  } catch (err) {
    return;
    // yield call(InternalError, err)
  }
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};

const removeScribeDetails = function* ({ payload }) {
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  try {
    const { courseid, candidateid, scribeType } = payload;
    // const result = yield put(() =>
    //   axios.get(
    //     `${process.env.REACT_APP_API_URL}/ candidate/course/registraton/scribe-details/delete?candidateid=${encodeURIComponent(
    //       EncryptFunction(candidateid)
    //     )}&courseid${encodeURIComponent(EncryptFunction(courseid))}&scribetype=${scribeType}`
    //   )
    // );

    const result = yield call(
  axios.delete,
  `${process.env.REACT_APP_API_URL}/candidate/course/registraton/scribe-details/delete` +
    `?candidateid=${encodeURIComponent(EncryptFunction(candidateid))}` +
    `&courseid=${encodeURIComponent(EncryptFunction(courseid))}` +
    `&scribetype=${encodeURIComponent(EncryptFunction(scribeType))}`
);
    
    yield call(handleDecodeJSON, {
      decodeJSON: result?.data?.result,
    });
    if(result?.data?.statusCode === 200){
        yield put({
        type: candidatesActions.GET_SCRIBE_DETAILS,
        payload: { candidateid: candidateid, courseid: courseid }
      });
      yield put({
        type: candidatesActions.GET_COURSE_ACTIVE_TAB,
        payload: {
              data: {
                courseid: parseInt(courseid) || parseInt(sessionStorage.getItem("courseid")),
                candidateid: parseInt(candidateid),
              },
            },
      })
            yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.statusCode === 200 ? "success" : "failed",
          show: true,
          message: "Scribe removed successfully",
        },
      });
    }
    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: null,
        show: false,
        message: null,
      },
    });
    yield call(ExternalError, result)
    // window.location.reload()
    // Reload the page
      //  window.location.reload();
    yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
  } catch (err) {
    return;
    // yield call(InternalError, err)
  }
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};

const getScribe1PhotoDetails = function* ({ payload }) {
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  try {
    const { courseid, candidateid } = payload;
    console.log(candidateid, courseid,"lkjhgfdswqertyuio")
    const result = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_URL}/candidate/course/registraton/scribe-details?candidateid=${encodeURIComponent(
          EncryptFunction(candidateid)
        )}&courseid=${encodeURIComponent(EncryptFunction(courseid))}&fieldname=scribe1photo`
      )
    );
    const decryptedData = yield call(handleDecodeJSON, {
      decodeJSON: result?.data?.result,
    });
    yield put({
      type: candidatesActions.SET_SCRIBE1_PHOTO_DETAILS,
      payload: result?.data?.statusCode === 200 ? decryptedData : [],
    });
    // yield call(ExternalError, result)
    yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
  } catch (err) {
    // yield call(InternalError, err)
  }
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};

const getScribe2PhotoDetails = function* ({ payload }) {
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  try {
    const { courseid, candidateid } = payload;
    const result = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_URL}/candidate/course/registraton/scribe-details?candidateid=${encodeURIComponent(
          EncryptFunction(candidateid)
        )}&courseid=${encodeURIComponent(EncryptFunction(courseid))}&fieldname=scribe2photo`
      )
    );
    const decryptedData = yield call(handleDecodeJSON, {
      decodeJSON: result?.data?.result,
    });
    yield put({
      type: candidatesActions.SET_SCRIBE2_PHOTO_DETAILS,
      payload: result?.data?.statusCode === 200 ? decryptedData : [],
    });
    // yield call(ExternalError, result)
    yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
  } catch (err) {
    // yield call(InternalError, err)
  }
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};

const getScribe1DocDetails = function* ({ payload }) {
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  try {
    const { courseid, candidateid } = payload;
    const result = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_URL}/candidate/course/registraton/scribe-details?candidateid=${encodeURIComponent(
          EncryptFunction(candidateid)
        )}&courseid=${encodeURIComponent(EncryptFunction(courseid))}&fieldname=scribe1document`
      )
    );
    const decryptedData = yield call(handleDecodeJSON, {
      decodeJSON: result?.data?.result,
    });
    yield put({
      type: candidatesActions.SET_SCRIBE1_DOC_DETAILS,
      payload: result?.data?.statusCode === 200 ? decryptedData : [],
    });
    yield call(ExternalError, result)
    yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
  } catch (err) {
    yield call(InternalError, err)
  }
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};

const getScribe2DocDetails = function* ({ payload }) {
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  try {
    const { courseid, candidateid } = payload;
    const result = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_URL}/candidate/course/registraton/scribe-details?candidateid=${encodeURIComponent(
          EncryptFunction(candidateid)
        )}&courseid=${encodeURIComponent(EncryptFunction(courseid))}&fieldname=scribe2document`
      )
    );
    const decryptedData = yield call(handleDecodeJSON, {
      decodeJSON: result?.data?.result,
    });
    yield put({
      type: candidatesActions.SET_SCRIBE2_DOC_DETAILS,
      payload: result?.data?.statusCode === 200 ? decryptedData : [],
    });
    yield call(ExternalError, result)
    yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
  } catch (err) {
    yield call(InternalError, err)
  }
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};

const getScribe1QualifyDocDetails = function* ({ payload }) {
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  try {
    const { courseid, candidateid } = payload;
    const result = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_URL}/candidate/course/registraton/scribe-details?candidateid=${encodeURIComponent(
          EncryptFunction(candidateid)
        )}&courseid=${encodeURIComponent(EncryptFunction(courseid))}&fieldname=scribe1qualificationdocument`
      )
    );
    const decryptedData = yield call(handleDecodeJSON, {
      decodeJSON: result?.data?.result,
    });
    yield put({
      type: candidatesActions.SET_SCRIBE1_QUALIFY_DOC_DETAILS,
      payload: result?.data?.statusCode === 200 ? decryptedData : [],
    });
    yield call(ExternalError, result)
    yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
  } catch (err) {
    yield call(InternalError, err)
  }
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};

const getScribe2QualifyDocDetails = function* ({ payload }) {
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  try {
    const { courseid, candidateid } = payload;
    const result = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_URL}/candidate/course/registraton/scribe-details?candidateid=${encodeURIComponent(
          EncryptFunction(candidateid)
        )}&courseid=${encodeURIComponent(EncryptFunction(courseid))}&fieldname=scribe2qualificationdocument`
      )
    );
    const decryptedData = yield call(handleDecodeJSON, {
      decodeJSON: result?.data?.result,
    });
    yield put({
      type: candidatesActions.SET_SCRIBE2_QUALIFY_DOC_DETAILS,
      payload: result?.data?.statusCode === 200 ? decryptedData : [],
    });
    yield call(ExternalError, result)
    yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
  } catch (err) {
    yield call(InternalError, err)
  }
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};

const getFullCandidateDetails = function* (data) {
  const candidateid = yield select(
    (state) => state?.authReducer?.candidateTokenDetails?.candidateid
  );
  try {
    const result = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_URL}/candidate/registration/details/${encodeURIComponent(
          EncryptFunction(candidateid)
        )}`
      )
    );
    const decryptedData = yield call(handleDecodeJSON, {
      decodeJSON: result?.data?.result,
    });

    yield put({
      type: candidatesActions.SET_FULL_CANDIDATE_DETAILS,
      payload: result?.data?.statusCode === 200 ? decryptedData : [],
    });
    yield call(ExternalError, result)
  } catch (err) {
    yield call(InternalError, err)



  }
};
const getFullCandidateDetail = function* (data) {
  const candidateid = yield select(
    (state) => state?.authReducer?.candidateTokenDetails?.candidateid
  );
  try {
    const result = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_URL}/candidate/registration/details/${encodeURIComponent(
          EncryptFunction(candidateid)
        )}`
      )
    );
    const decryptedData = yield call(handleDecodeJSON, {
      decodeJSON: result?.data?.result,
    });

    yield put({
      type: candidatesActions.SET_FULL_CANDIDATE_DETAILS,
      payload: result?.data?.statusCode === 200 ? decryptedData : [],
    });
    yield call(ExternalError, result)
  } catch (err) {
    yield call(InternalError, err)



  }
};

const getProfilePersonalDetails = function* () {
  // yield put({ type: authActions.CANDIDATE_TOKEN_VERIFY });
  // yield delay(200);
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  const candidateid = yield select(
    (state) => state?.authReducer?.candidateTokenDetails?.candidateid
  );
  try {
    // console.log(candidateid,"pks")
    const result = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_URL}/candidate/registration/${encodeURIComponent(
          EncryptFunction(candidateid)
        )}`
      )
    );
    const decryptedData = yield call(handleDecodeJSON, {
      decodeJSON: result?.data?.result,
    });
    // console.log(decryptedData,'personal')
    // console.log(decryptedData,"pks")
    if (result) {
      // console.log(decryptedData,'pks')
      yield put({
        type: candidatesActions.SET_PROFILE_PERSONAL_DETAILS,
        payload: decryptedData,
      });
      yield call(ExternalError, result);
    }
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
  } catch (err) {
    yield call(InternalError, err)
  } finally {
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
  }
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};

const getCategoryPersonalDetails = function* () {
  const candidateid = yield select(
    (state) => state?.authReducer?.candidateTokenDetails?.candidateid
  );
  try {
    const result = yield call(
      async () =>
        await axios.get(`${process.env.REACT_APP_API_URL}/candidate/registration/category/${12}`)
    );

    if (result) {
      yield put({
        type: candidatesActions.SET_CATEGORY_PERSONAL_DETAILS,
        payload: result?.data?.result,
      });
      yield call(ExternalError, result);
    }
  } catch (err) {
    yield call(InternalError, err)


  }
};

const getAddressPersonalDetails = function* (data) {
  const { payload } = data;
  const candidateidid = yield select(
    (state) => state?.authReducer?.candidateTokenDetails?.candidateid
  );
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });

  try {
    const result = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_URL}/candidate/registration/address/${encodeURIComponent(
          EncryptFunction(candidateidid)
        )}`
      )
    );

    const { statusCode } = result?.data || {};
    const decryptedData = yield call(handleDecodeJSON, {
      decodeJSON: result?.data?.result,
    });

    if (result) {
      yield put({
        type: candidatesActions.SET_ADDRESS_PERSONAL_DETAILS,
        payload: decryptedData,
      });

      if (statusCode === 200 && decryptedData?.length > 0) {
        const [row] = decryptedData;
if(payload?.loadMaster==true){
        // 🔹 Load states first
        yield put({ type: masterActions.GET_STATE });
        yield take(masterActions.SET_STATE); // wait for state list

        if (row?.pstateid) {
          yield put({
            type: masterActions.GET_DISTRICT_FOR_REGISTRATION,
            payload: { stateid: row.pstateid, type: "parmanent" },
          });
          yield take(masterActions.SET_DISTRICT_FOR_REGISTRATION);
        }

        if (row?.pdistrictid) {
          yield put({
            type: masterActions.GET_TALUKA_FOR_REGISTRATION,
            payload: { districtid: row.pdistrictid, type: "parmanent" },
          });
          yield take(masterActions.SET_TALUKA_FOR_REGISTRATION);
        }

        if (row?.ptalukaid) {
          yield put({
            type: masterActions.GET_VILLAGE_FOR_REGISTRATION,
            payload: { talukaid: row.ptalukaid, type: "parmanent" },
          });
          yield take(masterActions.SET_VILLAGE_FOR_REGISTRATION);
        }

        if (row?.cstateid) {
          yield put({
            type: masterActions.GET_DISTRICT_FOR_REGISTRATION,
            payload: { stateid: row.cstateid, type: "corespondence" },
          });
          yield take(masterActions.SET_DISTRICT_FOR_REGISTRATION);
        }

        if (row?.cdistrictid) {
          yield put({
            type: masterActions.GET_TALUKA_FOR_REGISTRATION,
            payload: { districtid: row.cdistrictid, type: "corespondence" },
          });
          yield take(masterActions.SET_TALUKA_FOR_REGISTRATION);
        }

        if (row?.ctalukaid) {
          yield put({
            type: masterActions.GET_VILLAGE_FOR_REGISTRATION,
            payload: { talukaid: row.ctalukaid, type: "corespondence" },
          });
          yield take(masterActions.SET_VILLAGE_FOR_REGISTRATION);
        }
        }
      }

      yield call(ExternalError, result);
    }
  } catch (err) {
    yield call(InternalError, err);
  }

  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};


const getEducationPersonalDetails = function* () {
  const candidateidid = yield select(
    (state) => state?.authReducer?.candidateTokenDetails?.candidateid
  );
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.get(`${process.env.REACT_APP_API_URL}/candidate/registration/education/${candidateidid}`)
    );
    if (result) {
      yield put({
        type: candidatesActions.SET_EDUCATION_PERSONAL_DETAILS,
        payload: result?.data?.result,
      });
      yield call(ExternalError, result);
    }
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
  } catch (err) {
    yield call(InternalError, err)


  }
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};

const getExamPersonalDetails = function* () {
  const candidateidid = yield select(
    (state) => state?.authReducer?.candidateTokenDetails?.candidateid
  );
  try {
    const result = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_URL}/candidate/registration/exampreference/${candidateidid}`
      )
    );
    if (result) {
      yield put({
        type: candidatesActions.SET_EXAM_PERSONAL_DETAILS,
        payload: result?.data?.result,
      });
      yield call(ExternalError, result);
    }
  } catch (err) {
    yield call(InternalError, err)


  }
};

const getCertificatePersonalDetails = function* () {
  const candidateidid = yield select(
    (state) => state?.authReducer?.candidateTokenDetails?.candidateid
  );
  try {
    const result = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_URL}/candidate/registration/certificates/${candidateidid}`
      )
    );
    if (result) {
      yield put({
        type: candidatesActions.SET_CERTIFICATE_PERSONAL_DETAILS,
        payload: result?.data?.result,
      });
      yield put({ type: masterActions.GET_ALL_DISTRICT });
      if (result?.data?.result[0]?.ewsdistrictid) {
        yield put({
          type: masterActions.GET_TALUKA,
          payload: result?.data?.result[0]?.ewsdistrictid,
        });
      }
      yield call(ExternalError, result);
    }
  } catch (err) {
    yield call(InternalError, err)


  }
};

const profilePersonalDetailsCreation = function* (data) {
  const candidateidid = yield select(
    (state) => state?.authReducer?.candidateTokenDetails?.candidateid
  );
  const { payload } = data;
  const { navigate } = payload;
  const encodedData = yield call(handleEncodeJson, {
    encodeJSON: payload?.data,
  });
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.put(
        `${process.env.REACT_APP_API_URL}/candidate/registration/${encodeURIComponent(
          EncryptFunction(candidateidid)
        )}`,
        encodedData
      )
    );
    if (result) {
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.statusCode === 200 ? "success" : "failed",
          show: true,
          message: result?.data?.message,
        },
      });
      if (result?.data?.statusCode === 200) {
        yield put({ type: candidatesActions.GET_PROFILE_PERSONAL_DETAILS });
        navigate("/mhcet/registration?page=address");
        yield put({
          type: authActions.GET_PROFILE_SUMMARY,
        });
      }
    }
    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: null,
        show: false,
        message: null,
      },
    });
  } catch (err) {
    yield call(InternalError, err)
  }
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};

const personalDetailsDraftCreation = function* (data) {
  const { payload } = data;
  yield put({ type: commonActions.SET_DRAFT_BUTTON_LOADER, payload: true });
  try {
    const encodedData = yield call(handleEncodeJson, {
      encodeJSON: payload?.data,
    });
    const profileSummary = yield select(
  (state) => state?.authReducer?.ProfileSummaryDetails
);  
    const candidateid = yield select(
      (state) => state?.authReducer?.candidateTokenDetails?.candidateid
    ) || profileSummary[0]?.candidateid;
    const result = yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_URL}/candidate/draft/personaldetails/${encodeURIComponent(
          EncryptFunction(candidateid)
        )}`,
        encodedData
      )
    );
    if (result) {
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.statusCode === 200 ? "success" : "failed",
          show: true,
          message: result?.data?.message,
        },
      });
      yield put({ type: candidatesActions.GET_PROFILE_PERSONAL_DETAILS });

    }
    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: null,
        show: false,
        message: null,
      },
    });
  } catch (err) {
    yield call(InternalError, err)


  }
  yield put({ type: commonActions.SET_DRAFT_BUTTON_LOADER, payload: false });
};

const addressPersonalDetailsCreation = function* (data) {
  const { payload } = data;
  const { navigate } = payload;
  const candidateidid = yield select(
    (state) => state?.authReducer?.candidateTokenDetails?.candidateid
  );
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  try {
    const encodedData = yield call(handleEncodeJson, {
      encodeJSON: payload?.data,
    });

    const result = yield call(() =>
      axios.post(`${process.env.REACT_APP_API_URL}/candidate/registration/address`, encodedData)
    );
    if (result) {
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.statusCode === 200 ? "success" : "failed",
          show: true,
          message: result?.data?.message,
        },
      });
      if (result?.data?.statusCode === 200) {
        navigate("/mhcet/registration?page=otherdetails");
        yield put({ type: candidatesActions.GET_ADDRESS_PERSONAL_DETAILS });
        yield put({
          type: authActions.GET_PROFILE_SUMMARY,
        });
      }
    }
    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: null,
        show: false,
        message: null,
      },
    });
  } catch (err) {
    yield call(InternalError, err)
  }
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};

const personalAddressDetailsDraftCreation = function* (data) {
  const { payload } = data;
  yield put({ type: commonActions.SET_DRAFT_BUTTON_LOADER, payload: true });
  try {
    const encodedData = yield call(handleEncodeJson, {
      encodeJSON: payload?.data,
    });
    const candidateidid = yield select(
      (state) => state?.authReducer?.candidateTokenDetails?.candidateid
    );
    const result = yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_URL}/candidate/draft/address/${encodeURIComponent(
          EncryptFunction(candidateidid)
        )}`,
        encodedData
      )
    );
    if (result) {
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.statusCode === 200 ? "success" : "failed",
          show: true,
          message: result?.data?.message,
        },
      });
    }
    yield put({ type: candidatesActions.GET_ADDRESS_PERSONAL_DETAILS });
    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: null,
        show: false,
        message: null,
      },
    });
  } catch (err) {
    yield call(InternalError, err)


  }
  yield put({ type: commonActions.SET_DRAFT_BUTTON_LOADER, payload: false });
};

const otherDetailsCreation = function* (data) {
  const { payload } = data;
  const { navigate } = payload;
  const candidateidid = yield select(
    (state) => state?.authReducer?.candidateTokenDetails?.candidateid
  );
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  try {
    const encodedData = yield call(handleEncodeJson, {
      encodeJSON: payload?.data,
    });
    const result = yield call(() =>
      axios.post(`${process.env.REACT_APP_API_URL}/candidate/registration/otherdetails`, encodedData)
    );
    if (result) {
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.statusCode === 200 ? "success" : "failed",
          show: true,
          message: result?.data?.message,
        },
      });
      if (result?.data?.statusCode === 200) {
        yield put({ type: candidatesActions.GET_OTHER_PERSONAL_DETAILS })
        navigate("/mhcet/registration?page=uploads",{
         previewFlag: false,
        });
        yield put({
          type: authActions.GET_PROFILE_SUMMARY,
        });
      }
    }
    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: null,
        show: false,
        message: null,
      },
    });
  } catch (err) {
    yield call(InternalError, err)


  }
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};

const otherDetailsDraftCreation = function* (data) {
  const { payload } = data;
  yield put({ type: commonActions.SET_DRAFT_BUTTON_LOADER, payload: true });
  try {
    const encodedData = yield call(handleEncodeJson, {
      encodeJSON: payload?.data,
    });
    const candidateidid = yield select(
      (state) => state?.authReducer?.candidateTokenDetails?.candidateid
    );
    const result = yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_URL}/candidate/draft/otherdetails/${encodeURIComponent(
          EncryptFunction(candidateidid)
        )}`,
        encodedData
      )
    );
    if (result) {
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.statusCode === 200 ? "success" : "failed",
          show: true,
          message: result?.data?.message,
        },
      });

      yield put({ type: candidatesActions.GET_OTHER_PERSONAL_DETAILS });
    }
    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: null,
        show: false,
        message: null,
      },
    });
  } catch (err) {
    yield call(InternalError, err)


  }
  yield put({ type: commonActions.SET_DRAFT_BUTTON_LOADER, payload: false });
};

const getOtherDetails = function* (data) {
  // yield put({ type: authActions.CANDIDATE_TOKEN_VERIFY });
  // yield delay(200);
  const {payload} = data  
  const candidateidid = yield select(
    (state) => state?.authReducer?.candidateTokenDetails?.candidateid
  ) || payload?.candidateid;

  
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_URL}/candidate/registration/otherdetails/${encodeURIComponent(
          EncryptFunction(candidateidid)
        )}`
      )
    );
    const decryptedData = yield call(handleDecodeJSON, {
      decodeJSON: result?.data?.result,
    });
    if (result) {
      yield put({
        type: candidatesActions.SET_OTHER_PERSONAL_DETAILS,
        payload: decryptedData,
      });
      yield call(ExternalError, result);
    }
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
  } catch (err) {
    yield call(InternalError, err)


  }
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};

const getUploadDetails = function* () {
  // yield put({ type: authActions.CANDIDATE_TOKEN_VERIFY });
  // yield delay(200);
  const candidateidid = yield select(
    (state) => state.authReducer?.ProfileSummaryDetails[0]?.candidateid
  );
  try {
    if (candidateidid) {
      yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
      const result = yield call(() =>
        axios.get(
          `${process.env.REACT_APP_API_URL}/candidate/registration/uploads/${encodeURIComponent(
            EncryptFunction(candidateidid)
          )}`
        )
      );
      const decryptedData = yield call(handleDecodeJSON, {
        decodeJSON: result?.data?.encryptedData,
      });
      if (result) {
        // const isSuccess = result?.data?.statusCode == 200;

        // if (isSuccess) {
        //   sessionStorage.setItemgetItem('uploaddetails', 'true', { expires: 7 }); // Expires in 7 days
        // }
        yield put({
          type: candidatesActions.SET_UPLOAD_PERSONAL_DETAILS,
          payload: result?.data?.statusCode === 200 ? decryptedData : [],
        });
        yield call(ExternalError, result);
      }
      yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
    }
  } catch (err) {
    yield call(InternalError, err);
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });

  }
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};
const getCourseUploadDetails = function* (payload) {
  // yield put({ type: authActions.CANDIDATE_TOKEN_VERIFY });
  // yield delay(200);
  // const courseId = payload?.data?.courseid;
  const profileSummary = yield select(
  (state) => state?.authReducer?.ProfileSummaryDetails
);  
  const candidateidid = yield select(
    (state) => state?.authReducer?.candidateTokenDetails?.candidateid
  ) || profileSummary[0]?.candidateid;
  let candidateid = payload?.data?.candidateid || candidateidid;
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_URL}/candidate/registration/courseuploads/${encodeURIComponent(
          EncryptFunction(candidateid || payload?.data?.candidateid)
        )}/${encodeURIComponent(EncryptFunction(payload?.data?.courseid))}`
        // `${process.env.REACT_APP_API_URL}/candidate/registration/courseuploads/${candidateidid}/${courseId}`
      )
    );
    const decryptedData = yield call(handleDecodeJSON, {
      decodeJSON: result?.data?.encryptedData,
    });
    if (result) {
      yield put({
        type: candidatesActions.SET_COURSE_UPLOAD_PERSONAL_DETAILS,
        payload: result?.data?.statusCode === 200 ? decryptedData : [],
      });
    }
    yield call(ExternalError, result)
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
  } catch (err) {
    yield call(InternalError, err)


  }
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};

const categoryPersonalDetailsCreation = function* (data) {
  const { payload } = data;
  const { navigate } = payload;
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.post(`${process.env.REACT_APP_API_URL}/candidate/registration/category`, payload.data)
    );
    if (result) {
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.statusCode === 200 ? "success" : "failed",
          show: true,
          message: result?.data?.message,
        },
      });
      navigate("/mhcet/registration?page=education");
    }
  } catch (err) {
    yield call(InternalError, err)
  }
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};

const personalCategoryDetailsDraftCreation = function* (data) {
  const { payload } = data;
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.post(`${process.env.REACT_APP_API_URL}/candidate/draft/category`, payload.data)
    );
    if (result) {
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.statusCode === 200 ? "success" : "failed",
          show: true,
          message: result?.data?.message,
        },
      });
      yield delay(2000);
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: null,
          show: false,
          message: null,
        },
      });
    }
  } catch (err) {
    yield call(InternalError, err)


  }
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};

const educationPersonalDetailsCreation = function* (data) {
  const { payload } = data;
  const { navigate } = payload;
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.post(`${process.env.REACT_APP_API_URL}/candidate/registration/education`, payload.data)
    );
    if (result) {
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.statusCode === 200 ? "success" : "failed",
          show: true,
          message: result?.data?.message,
        },
      });
      navigate("/mhcet/registration?page=exampreference");
    }
  } catch (err) {
    yield call(InternalError, err)


  }
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};

const personalEducationDetailsDraftCreation = function* (data) {
  const { payload } = data;
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.post(`${process.env.REACT_APP_API_URL}/candidate/draft/education`, payload.data)
    );
    if (result) {
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.statusCode === 200 ? "success" : "failed",
          show: true,
          message: result?.data?.message,
        },
      });
      yield (2000);
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: null,
          show: false,
          message: null,
        },
      });

    }
  } catch (err) {
    yield call(InternalError, err)


  }
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};

const examPersonalDetailsCreation = function* (data) {
  const { payload } = data;
  const { navigate } = payload;
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_URL}/candidate/registration/exampreference`,
        payload.data
      )
    );
    if (result) {
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.statusCode === 200 ? "success" : "failed",
          show: true,
          message: result?.data?.message,
        },
      });
      navigate("/mhcet/registration?page=certificates");
    }
  } catch (err) {
    yield call(InternalError, err)


  }
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};

const personalExamDetailsDraftCreation = function* (data) {
  const { payload } = data;
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.post(`${process.env.REACT_APP_API_URL}/candidate/draft/exampreference`, payload.data)
    );
    if (result) {
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.statusCode === 200 ? "success" : "failed",
          show: true,
          message: result?.data?.message,
        },
      });
      yield delay(2000);
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: null,
          show: false,
          message: null,
        }
      });


    }
  } catch (err) {
    yield call(InternalError, err)


  }
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};

const certificatesPersonalDetailsCreation = function* (data) {
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  const { payload } = data;
  const { navigate } = payload;
  try {
    const result = yield call(() =>
      axios.post(`${process.env.REACT_APP_API_URL}/candidate/registration/certificates`, payload.data)
    );
    if (result) {
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.statusCode === 200 ? "success" : "failed",
          show: true,
          message: result?.data?.message,
        },
      });
      navigate("/mhcet/registration?page=uploads");
    }
  } catch (err) {
    yield call(InternalError, err)


  }
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};

const personalCertificatesDetailsDraftCreation = function* (data) {
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  const { payload } = data;
  try {
    const result = yield call(() =>
      axios.post(`${process.env.REACT_APP_API_URL}/candidate/draft/certificates`, payload.data)
    );
    if (result) {
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.statusCode === 200 ? "success" : "failed",
          show: true,
          message: result?.data?.message,
        },
      });
      yield delay(2000);
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: null,
          show: false,
          message: null,
        },
      });
    }
  } catch (err) {
    yield call(InternalError, err)


  }
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};

const uploadsPersonalDetailsCreation = function* (action) {
  const candidateidid = yield select(
    (state) => state?.authReducer?.candidateTokenDetails?.candidateid
  );
  const { payload } = action;
  const { navigate, editStatus, coursename, courseid,courseId,courseName,previewFlag } = payload;
  const fileType = payload?.data?.filetype;
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  try {
    const formData = new FormData();
    const photoFile = new File(
      [payload.data.photofilename],
      `${candidateidid}_photo.jpeg`,
      { type: "image/jpeg" }
    );
    const signFile = new File(
      [payload.data.signfilename],
      `${candidateidid}_signature.jpeg`,
      {
        type: "image/jpeg",
      }
    );
    const documentFile = new File(
      [payload.data.documentfilename],
      payload?.data?.documentfilename?.name,
      {
        type:
          fileType == "pdf"
            ? "application/pdf"
            : fileType == "jpg"
              ? "image/jpeg"
              : fileType == "png"
                ? "image/png"
                : fileType == "docx"
                  ? "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  : fileType === "doc"
                    ? "application/msword"
                    : "",
      }
    );

    const udiddocumentfile = payload.data.udiddocument
      ? new File(
        [payload.data.udiddocument],
        payload?.data?.udiddocument?.name,
        {
          type:
            fileType == "pdf"
              ? "application/pdf"
              : fileType == "jpg"
                ? "image/jpeg"
                : fileType == "png"
                  ? "image/png"
                  : fileType == "docx"
                    ? "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                    : fileType === "doc"
                      ? "application/msword"
                      : "",
        }
      )
      : null;

      const annexuredocumentfile = payload.data.annexurefilename
      ? new File(
        [payload.data.annexurefilename],
        payload?.data?.annexurefilename?.name,
        {
          type:
            fileType == "pdf"
              ? "application/pdf"
              : fileType == "jpg"
                ? "image/jpeg"
                : fileType == "png"
                  ? "image/png"
                  : fileType == "docx"
                    ? "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                    : fileType === "doc"
                      ? "application/msword"
                      : "",
        }
      )
      : null;
    const operation = payload.data.operation;
    const candidateid = payload.data.candidateid;
    const courseid = payload.data.courseid;
    const isdisability = payload.data.isdisability;
    const documentid = payload.data.documentid;
    const status = payload.data.status;

    formData.append(
      "photofilename",
      payload?.data?.photofilename ? photoFile : ""
    );
    formData.append("signfilename", payload.data.signfilename ? signFile : "");
    formData.append(
      "documentfilename",
      payload.data.documentfilename ? documentFile : ""
    );

    formData.append(
      "photoUrl",
      payload?.data?.photofilename ? "" : payload?.data?.photoUrl
    );
    formData.append(
      "signUrl",
      payload?.data?.signfilename ? "" : payload?.data?.signUrl
    );
    formData.append(
      "docUrl",
      payload?.data?.documentfilename ? "" : payload?.data?.docUrl
    );

    formData.append(
      "photoname",
      payload?.data?.photoname ? payload?.data?.photoname : ""
    );
    formData.append(
      "signname",
      payload.data.signname ? payload.data.signname : ""
    );
    formData.append(
      "docname",
      payload.data.docname ? payload.data.docname : ""
    );

    formData.append("operation", operation);
    formData.append("candidateid", candidateid);
    formData.append("courseid", courseid);
    formData.append("isdisability", isdisability);
    formData.append("documentid", documentid);
    formData.append("status", status);
    formData.append("udiddocument", payload.data.udiddocument ? udiddocumentfile : "");
    formData.append("annexurefilename", payload.data.annexurefilename ? annexuredocumentfile : "");
    formData.append("udidUrl", payload?.data?.udiddocument ? "" : payload?.data?.udidUrl);
    formData.append("annexureUrl", payload?.data?.annexurefilename ? "" : payload?.data?.annexureUrl);
    formData.append("frompreview",payload?.data?.fromPreview ? payload?.data?.fromPreview : "false");
    formData.append("filetype", fileType ? fileType : "");

    for (let [key, value] of formData.entries()) {
  console.log(key, value, "poiuytrewqwsdfghjkl");
}

    const result = yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_URL}/candidate/registration/uploads/${encodeURIComponent(
          EncryptFunction(candidateidid)
        )}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )
    );
    if (result?.data?.statusCode === 200) {
      yield put({
        type: authActions.GET_PROFILE_SUMMARY,
      });
       const project = sessionStorage.getItem("mhet_cnd_project");
  
      // console.log(previewFlag,'pks')
      
    const queryParams = {
    courseid: courseid,
    coursename: coursename,
  };
  const encryptedParams = EncryptObjectFunction(queryParams);
const { bypassRegistrationData } = yield select(
  (state) => state.candidatesReducer
);
// const hasClosed = bypassRegistrationData?.toLowerCase()?.includes("closed");

const hasClosed =
  typeof bypassRegistrationData === "string" &&
  bypassRegistrationData?.toLowerCase()?.includes("closed");



  let targetUrl = "";

  if (previewFlag === "true") {
    targetUrl = `/${project}/course-registration?page=preview&courseid=${encodeURIComponent(EncryptFunction(courseId))}&coursename=${encodeURIComponent(courseName)}`;
  } else if(editStatus === 1 && previewFlag === "false"){
targetUrl=`/${project}/editing-facility?c_data=${encryptedParams}`
  }else if(payload?.data?.fromPreview && previewFlag === "false"){
targetUrl=`/${project}/course-registration?page=preview&courseid=${EncryptFunction(payload?.data?.courseid )}&coursename=${encodeURIComponent(payload?.data?.coursename)}`
  } else if(hasClosed) {
    // targetUrl = `${process.env.REACT_APP_KEYCLOAK_REDIRECT_URI}`
    window.location.href = `${process.env.REACT_APP_KEYCLOAK_REDIRECT_URI}`;
  } else {
    // targetUrl = `/${project}/home`;
    targetUrl = `/${project}/course-registration?page=personalinformation&courseid=${EncryptFunction(payload?.data?.courseid )}&coursename=${encodeURIComponent(payload?.data?.coursename)}`;
  } 


  // else {
  //   // Default to course registration preview
  //   targetUrl = `/${project}/course-registration?page=preview&courseid=${EncryptFunction(
  //     payload?.data?.courseid
  //   )}&coursename=${encodeURIComponent(payload?.data?.coursename)}`;
  // }
  // const encryptedParams = EncryptObjectFunction(queryParams);
  //     editStatus === 1
  //       ? navigate(
  //           `/${sessionStorage.getItem(
  //             "mhet_cnd_project"
  //           )}/editing-facility?c_data=${encryptedParams}`
  //         )
  //       : payload?.data?.fromPreview
  //       ? navigate(
  //           `/${sessionStorage.getItem(
  //             "mhet_cnd_project"
  //           )}/course-registration?page=preview&courseid=${EncryptFunction(
  //             payload?.data?.courseid
  //           )}&coursename=${encodeURIComponent(payload?.data?.coursename)}`,
  //           {
  //             state: {
  //               courseid: payload?.data?.courseid,
  //               coursename: payload?.data?.coursename,
  //             },
  //           }
  //         )
       

  navigate(targetUrl, {
  state: { courseId, courseName }});
  sessionStorage.setItem("preview",false)
          // : navigate(`/${sessionStorage.getItem("mhet_cnd_project")}/home`);

      // if (!payload?.data?.fromPreview) {
      //   window.location.reload();
      // }
      // window.location.reload();
   
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: result?.data?.statusCode === 200 ? "success" : "failed",
        show: payload?.data?.fromPreview ? false : true,
        message: payload?.data?.fromPreview ? "" : result?.data?.message,
      },
    });
    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: null,
        show: false,
        message: null,
      },
    });
    yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
      }

  } catch (err) {
    yield call(InternalError, err)
    yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });


  }
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};

const uploadsDraftCreation = function* (action) {
  const candidateidid = yield select(
    (state) => state?.authReducer?.candidateTokenDetails?.candidateid
  );
  const { payload } = action;
  const fileType = payload?.data?.filetype;
  yield put({ type: commonActions.SET_DRAFT_BUTTON_LOADER, payload: true });
  try {
    const formData = new FormData();
    const photoFile = payload.data.photofilename
      ? new File([payload.data.photofilename], `${candidateidid}_photo.jpeg`, {
        type: "image/jpeg",
      })
      : null;
    const signFile = payload.data.signfilename
      ? new File(
        [payload.data.signfilename],
        `${candidateidid}_signature.jpeg`,
        {
          type: "image/jpeg",
        }
      )
      : null;
    const documentFile = payload.data.documentfilename
      ? new File(
        [payload.data.documentfilename],
        payload?.data?.documentfilename?.name,
        {
          type:
            fileType == "pdf"
              ? "application/pdf"
              : fileType == "jpg"
                ? "image/jpeg"
                : fileType == "png"
                  ? "image/png"
                  : fileType == "docx"
                    ? "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                    : fileType === "doc"
                      ? "application/msword"
                      : "",
        }
      )
      : null;

      const udiddocumentfile = payload.data.udiddocument
      ? new File(
        [payload.data.udiddocument],
        payload?.data?.udiddocument?.name,
        {
          type:
            fileType == "pdf"
              ? "application/pdf"
              : fileType == "jpg"
                ? "image/jpeg"
                : fileType == "png"
                  ? "image/png"
                  : fileType == "docx"
                    ? "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                    : fileType === "doc"
                      ? "application/msword"
                      : "",
        }
      )
      : null;

      const annexuredocumentfile = payload.data.annexurefilename
      ? new File(
        [payload.data.annexurefilename],
        payload?.data?.annexurefilename?.name,
        {
          type:
            fileType == "pdf"
              ? "application/pdf"
              : fileType == "jpg"
                ? "image/jpeg"
                : fileType == "png"
                  ? "image/png"
                  : fileType == "docx"
                    ? "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                    : fileType === "doc"
                      ? "application/msword"
                      : "",
        }
      )
      : null;

    const operation = payload.data.operation;
    const candidateid = payload.data.candidateid;
    const status = payload.data.status;

    formData.append(
      "photoUrl",
      payload?.data?.photofilename ? "" : payload?.data?.photoUrl
    );
    formData.append(
      "signUrl",
      payload?.data?.signfilename ? "" : payload?.data?.signUrl
    );
    formData.append(
      "docUrl",
      payload?.data?.documentfilename ? "" : payload?.data?.docUrl
    );

    formData.append(
      "photofilename",
      payload?.data?.photofilename ? photoFile : ""
    );
    formData.append("signfilename", payload.data.signfilename ? signFile : "");
    formData.append("udiddocument", payload.data.udiddocument ? udiddocumentfile : "");
    formData.append("annexurefilename", payload.data.annexurefilename ? annexuredocumentfile : "");
    formData.append(
      "documentfilename",
      payload.data.documentfilename ? documentFile : ""
    );

    formData.append("operation", operation);
    formData.append("candidateid", candidateid);
    formData.append(
      "documentid",
      payload?.data?.documentid ? payload?.data?.documentid : ""
    );
    formData.append("status", status);

    formData.append("filetype", fileType ? fileType : "");

    const result = yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_URL}/candidate/draft/uploads/${encodeURIComponent(
          EncryptFunction(candidateidid)
        )}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )
    );

    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: result?.data?.statusCode === 200 ? "success" : "failed",
        show: true,
        message: result?.data?.message,
      },
    });
    yield put({ type: candidatesActions.GET_UPLOAD_PERSONAL_DETAILS })
    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: null,
        show: false,
        message: null,
      },
    });

    // window.location.reload();
  } catch (err) {
    yield call(InternalError, err)



  }

  yield put({ type: commonActions.SET_DRAFT_BUTTON_LOADER, payload: false });
};

const grievanceQueryCreation = function* (data) {
  const { payload } = data;
  const { navigate } = payload;

  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });

  try {
    const formData = new FormData();

    for (let key in payload?.data) {
      formData.append(key, payload?.data[key]);
    }

    const result = yield call(() =>
      axios.post(`${process.env.REACT_APP_API_URL}/backoffice/grievance/ticket`, formData)
    );
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: result?.data?.statusCode === 200 ? "success" : "failed",
        show: true,
        message: result?.data?.message,
      },
    });
    if (result?.data?.statusCode === 200) {
      navigate(`/${sessionStorage.getItem("mhet_cnd_project")}/query-list`);
    }
    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: { status: null, show: false, message: null },
    });
  } catch (err) {
    yield call(InternalError, err)


  }
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};

const getQueryStatusByCandidate = function* () {
  const candidateidid = yield select(
    (state) => state?.authReducer?.candidateTokenDetails?.candidateid
  );
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_URL}/backoffice/grievance/ticket/candidate/${candidateidid}`
      )
    );
    if (result?.data?.statusCode === 200) {
      let finalArr = result?.data?.result?.map((val, i) => {
        return {
          ...val,
          id: i + 1,
          noofdays: calculateDaysDifference(
            new Date(val?.createddate),
            new Date()
          ),
          ticketraisedon: formatDate(val?.createddate),
          status:
            val?.status === 1
              ? "Open"
              : val?.status === 5
                ? "Closed"
                : "Pending",
          ticketClosedOn: val?.status === 5 ? formatDate(val?.updateddate) : "",
        };
      });
      yield put({
        type: candidatesActions.SET_QUERY_STATUS_BY_CANDIDATEID,
        payload: finalArr,
      });
    }
    yield call(ExternalError, result)
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
  } catch (err) {
    yield call(InternalError, err)


  }
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};

const getPincode = function* (data) {
  try {
    const { payload } = data;
    const result = yield call(() =>
      axios.get(`${process.env.REACT_APP_API_URL}/candidate/registration/pincode/${payload?.value}`)
    );
    if (result?.data?.statusCode === 200) {
      yield put({
        type: candidatesActions.SET_PINCODE,
        payload: result?.data?.result,
      });
      if (result?.data?.result[0]?.stateid) {
        yield put({
          type: masterActions.GET_DISTRICT_FOR_REGISTRATION,
          payload: {
            stateid: result?.data?.result[0]?.stateid,
            type: "parmanent",
          },
        });
        yield put({
          type: masterActions.GET_DISTRICT,
          payload: result?.data?.result[0]?.stateid,
        });
      }
      if (result?.data?.result[0]?.districtid) {
        yield put({
          type: masterActions.GET_TALUKA,
          payload: result?.data?.result[0]?.districtid,
        });
        yield put({
          type: masterActions.GET_TALUKA_FOR_REGISTRATION,
          payload: {
            districtid: result?.data?.result[0]?.districtid,
            type: "parmanent",
          },
        });
      }
      if (result?.data?.result[0]?.talukaid) {
        yield put({
          type: masterActions.GET_VILLAGE,
          payload: result?.data?.result[0]?.talukaid,
        });
        yield put({
          type: masterActions.GET_VILLAGE_FOR_REGISTRATION,
          payload: {
            talukaid: result?.data?.result[0]?.talukaid,
            type: "parmanent",
          },
        });
      }
      yield call(ExternalError, result)
    }
  } catch (err) {
    yield call(InternalError, err)


  }
};

const getPincodeCorrespondence = function* (data) {
  // console.log("getPincodeCorrespondence");

  try {
    const { payload } = data;
    const result = yield call(() =>
      axios.get(`${process.env.REACT_APP_API_URL}/candidate/registration/pincode/${payload?.value}`)
    );
    if (result?.data?.statusCode === 200) {
      yield put({
        type: candidatesActions.SET_PINCODE_CORRESPONDENCE,
        payload: result?.data?.result,
      });
      if (result?.data?.result[0]?.stateid) {
        yield put({
          type: masterActions.GET_DISTRICT,
          payload: result?.data?.result[0]?.stateid,
        });
        yield put({
          type: masterActions.GET_DISTRICT_FOR_REGISTRATION,
          payload: {
            stateid: result?.data?.result[0]?.stateid,
            type: "corespondence",
          },
        });
      }
      if (result?.data?.result[0]?.districtid) {
        yield put({
          type: masterActions.GET_TALUKA,
          payload: result?.data?.result[0]?.districtid,
        });
        yield put({
          type: masterActions.GET_TALUKA_FOR_REGISTRATION,
          payload: {
            districtid: result?.data?.result[0]?.districtid,
            type: "corespondence",
          },
        });
      }
      if (result?.data?.result[0]?.talukaid) {
        yield put({
          type: masterActions.GET_VILLAGE,
          payload: result?.data?.result[0]?.talukaid,
        });
        yield put({
          type: masterActions.GET_VILLAGE_FOR_REGISTRATION,
          payload: {
            talukaid: result?.data?.result[0]?.talukaid,
            type: "corespondence",
          },
        });
      }
      yield call(ExternalError, result)
    }
  } catch (err) {
    yield call(InternalError, err)


  }
};

const coursePersonaldetailsCreation = function* (data) {
  const { payload } = data;
  const { navigate, statusForRedirect } = payload;
  const encodedData = yield call(handleEncodeJson, {
    encodeJSON: payload?.data,
  });



  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  try {
    const profileSummary = yield select(
  (state) => state?.authReducer?.ProfileSummaryDetails
);  
    const candidateid = yield select(
      (state) => state?.authReducer?.candidateTokenDetails?.candidateid
    ) || profileSummary[0]?.candidateid;
    const result = yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_URL}/candidate/course/registraton/personaldetails/${encodeURIComponent(
          EncryptFunction(candidateid)
        )}`,
        encodedData
      )
    );
    
    if (result) {
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.statusCode == 200 ? "success" : "failed",
          show: true,
          message: result?.data?.message,
        },
      });
      // yield put({
      //   type: candidatesActions.GET_COURSE_FORM_DETAILS,
      //   payload: { courseid: payload?.data?.courseid },
      // })
      // yield delay(2000);
      yield put({ type: candidatesActions.GET_PROFILE_PERSONAL_DETAILS });
      yield put({
        type: candidatesActions.GET_COURSE_ACTIVE_TAB,
        payload: {
          data: {
            courseid: parseInt(payload?.data?.courseid),
            candidateid: parseInt(candidateid),
          },
        },
      });
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: null,
          show: false,
          message: null,
        },
      });
    }
    if (result?.data?.statusCode === 200) {
      if (statusForRedirect === 1) {
        navigate(
          `/${sessionStorage.getItem(
            "mhet_cnd_project"
          )}/course-registration?page=preview&courseid=${EncryptFunction(
            payload?.data?.courseid
          )}&coursename=${encodeURIComponent(payload?.data?.coursename)}`,
          {
            state: {
              courseid: payload?.data?.courseid,
              coursename: payload?.data?.coursename,
            },
          }
        );
      } else {
        navigate(
          `/${sessionStorage.getItem("mhet_cnd_project")}/course-registration?page=${payload?.nextPageName
          }`,
          {
            state: {
              courseid: payload?.data?.courseid,
              coursename: payload?.data?.coursename,
            },
          }
        );
      }
      // window.location.reload();
    } else if (result?.data?.statusCode === 410) {
      // yield put({
      //   type: commonActions.SET_ALERT,
      //   payload: {
      //     status: result?.data?.statusCode === 410 ? "success" : "failed",
      //     show: true,
      //     message: result?.data?.message,
      //   },
      // });
      alert("Your session has expired. Please re-login.")
      return  yield put({ type: authActions.CANDIDATE_LOGOUT });
        // navigate("/")
    } else if(result?.data?.statusCode === 450){
        yield put({
        type: commonActions.SHOW_CLOSE_TAB_MODAL,
        payload: true,
      });
    }else if(result?.data?.statusCode === 451){
       yield put({
        type: authActions.SET_APPAR_MANDATORY_DIALOG,
        payload : true
       })
    }
  } catch (err) {
    yield call(InternalError, err)
    // console.log(err,"error consoled")
  }
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};

const courseAddressdetailsCreation = function* (data) {
  const { payload } = data;
  const { navigate, statusForRedirect } = payload;
  const encodedData = yield call(handleEncodeJson, {
    encodeJSON: payload?.data,
  });
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  try {
    const profileSummary = yield select(
  (state) => state?.authReducer?.ProfileSummaryDetails
);  
    const candidateid = yield select(
      (state) => state?.authReducer?.candidateTokenDetails?.candidateid
    ) || profileSummary[0]?.candidateid;
    const result = yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_URL}/candidate/course/registraton/addressdetails/${encodeURIComponent(
          EncryptFunction(candidateid)
        )}`,
        encodedData
      )
    );
    if (result) {
      yield put({
        type: candidatesActions.GET_COURSE_ACTIVE_TAB,
        payload: {
          data: {
            courseid: parseInt(payload?.data?.courseid),
            candidateid: parseInt(candidateid),
          },
        },
      });
      yield put({
        type: candidatesActions.GET_COURSE_FORM_DETAILS,
        payload: { courseid: payload?.data?.courseid },
      })
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.statusCode === 200 ? "success" : "failed",
          show: true,
          message: result?.data?.message,
        },
      });
      yield delay(2000);
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: null,
          show: false,
          message: null,
        },
      });
    }
    if (result?.data?.statusCode === 200) {
      if (statusForRedirect === 1) {
        navigate(
          `/${sessionStorage.getItem(
            "mhet_cnd_project"
          )}/course-registration?page=preview&courseid=${EncryptFunction(
            payload?.data?.courseid
          )}&coursename=${encodeURIComponent(payload?.data?.coursename)}`,
          {
            state: {
              courseid: payload?.data?.courseid,
              coursename: payload?.data?.coursename,
            },
          }
        );
        // yield put({ type: candidatesActions.GET_COURSE_ADDRESS_DETAILS });
      } else {
        navigate(
          `/${sessionStorage.getItem("mhet_cnd_project")}/course-registration?page=${payload.nextPageName
          }`,
          {
            state: {
              courseid: payload?.data?.courseid,
              coursename: payload?.data?.coursename,
            },
          }
        );
      }
      // window.location.reload();
    } else if (result?.data?.statusCode === 410) {
      // yield put({
      //   type: commonActions.SET_ALERT,
      //   payload: {
      //     status: result?.data?.statusCode === 410 ? "success" : "failed",
      //     show: true,
      //     message: result?.data?.message,
      //   },
      // });
              alert("Your session has expired. Please re-login.")
      return  yield put({ type: authActions.CANDIDATE_LOGOUT });
        // navigate("/")
    } else if(result?.data?.statusCode === 450){
        yield put({
        type: commonActions.SHOW_CLOSE_TAB_MODAL,
        payload: true,
      });
    }else if(result?.data?.statusCode === 451){
       yield put({
        type: authActions.SET_APPAR_MANDATORY_DIALOG,
        payload : true
       })
    }
  } catch (err) {
    yield call(InternalError, err)


  }
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};

const courseAcademicdetailsCreation = function* (data) {
  const { payload } = data;
  const { navigate, statusForRedirect } = payload;
  const encodedData = yield call(handleEncodeJson, {
    encodeJSON: payload?.data,
  });
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  try {
    const profileSummary = yield select(
  (state) => state?.authReducer?.ProfileSummaryDetails
);  
    const candidateid = yield select(
      (state) => state?.authReducer?.candidateTokenDetails?.candidateid
    ) || profileSummary[0]?.candidateid;
    const result = yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_URL}/candidate/course/registraton/academicdetails/${encodeURIComponent(
          EncryptFunction(candidateid)
        )}`,
        encodedData
      )
    );
    if (result) {
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.statusCode === 200 ? "success" : "failed",
          show: true,
          message: result?.data?.message,
        },
      });
      if(result?.data?.statusCode === 401){
        alert("Your session has expired. Please re-login.")
      return  yield put({ type: authActions.CANDIDATE_LOGOUT });
        // navigate("/")
      }
      yield put({
        type: candidatesActions.GET_COURSE_FORM_DETAILS,
        payload: { courseid: payload?.data?.courseid },
      })
      yield put({
        type: candidatesActions.GET_COURSE_ACTIVE_TAB,
        payload: {
          data: {
            courseid: parseInt(payload?.data?.courseid),
            candidateid: parseInt(candidateid),
          },
        },
      });
      yield delay(2000);
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: null,
          show: false,
          message: null,
        },
      });
    }
    if (result?.data?.statusCode === 200) {
            yield put({ type: masterActions.GET_MOCK_DETAILS_VALUE, payload: { courseid: payload?.data?.courseid, candidateid }, });
        navigate(
          `/${sessionStorage.getItem("mhet_cnd_project")}/course-registration?page=${payload.nextPageName
          }`,
          {
            state: {
              courseid: payload?.data?.courseid,
              coursename: payload?.data?.coursename,
            },
          }
        );
      // }
      // window.location.reload();
    } else if (result?.data?.statusCode === 410) {
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.statusCode === 410 ? "success" : "failed",
          show: true,
          message: result?.data?.message,
        },
      });
    } else if(result?.data?.statusCode === 450){
        yield put({
        type: commonActions.SHOW_CLOSE_TAB_MODAL,
        payload: true,
      });
    }else if(result?.data?.statusCode === 451){
       yield put({
        type: authActions.SET_APPAR_MANDATORY_DIALOG,
        payload : true
       })
    }
  } catch (err) {
    yield call(InternalError, err)
  }
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};

const courseReservationdetailsCreation = function* (data) {
  const { payload } = data;
  const { navigate, statusForRedirect } = payload;
  const encodedData = yield call(handleEncodeJson, {
    encodeJSON: payload?.data,
  });
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  try {
    const profileSummary = yield select(
  (state) => state?.authReducer?.ProfileSummaryDetails
);  
    const candidateid = yield select(
      (state) => state?.authReducer?.candidateTokenDetails?.candidateid
    ) || profileSummary[0]?.candidateid;
    const result = yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_URL}/candidate/course/registraton/reservationdetails/${encodeURIComponent(
          EncryptFunction(candidateid)
        )}`,
        encodedData
      )
    );
    if (result) {
      console.log("entered here")
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.statusCode === 200 ? "success" : "failed",
          show: true,
          message: result?.data?.message,
        },
      });
      yield put({
        type: candidatesActions.GET_COURSE_FORM_DETAILS,
        payload: { courseid: payload?.data?.courseid },
      })
      yield put({
        type: candidatesActions.GET_COURSE_ACTIVE_TAB,
        payload: {
          data: {
            courseid: parseInt(payload?.data?.courseid),
            candidateid: parseInt(candidateid),
          },
        },
      });
      yield delay(2000);
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: null,
          show: false,
          message: null,
        },
      });
    }
    if (result?.data?.statusCode === 200) {
      // if (statusForRedirect === 1) {
      //   navigate(
      //     `/${sessionStorage.getItem(
      //       "mhet_cnd_project"
      //     )}/course-registration?page=preview&courseid=${EncryptFunction(
      //       payload?.data?.courseid
      //     )}&coursename=${encodeURIComponent(payload?.data?.coursename)}`,
      //     {
      //       state: {
      //         courseid: payload?.data?.courseid,
      //         coursename: payload?.data?.coursename,
      //       },
      //     }
      //   );
      // } else {
        navigate(
          `/${sessionStorage.getItem("mhet_cnd_project")}/course-registration?page=${payload.nextPageName
          }`,
          {
            state: {
              courseid: payload?.data?.courseid,
              coursename: payload?.data?.coursename,
            },
          }
        );
      // }
      // window.location.reload();
    } else if (result?.data?.statusCode === 410) {
      // yield put({
      //   type: commonActions.SET_ALERT,
      //   payload: {
      //     status: result?.data?.statusCode === 410 ? "success" : "failed",
      //     show: true,
      //     message: result?.data?.message,
      //   },
      // });
      alert("Your session has expired. Please re-login.")
      return  yield put({ type: authActions.CANDIDATE_LOGOUT });
        // navigate("/")
    } else if(result?.data?.statusCode === 450){
        yield put({
        type: commonActions.SHOW_CLOSE_TAB_MODAL,
        payload: true,
      });
    }else if(result?.data?.statusCode === 451){
       yield put({
        type: authActions.SET_APPAR_MANDATORY_DIALOG,
        payload : true
       })
    }
  } catch (err) {
    yield call(InternalError, err)


  }
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};

const courseExamdetailsCreation = function* (data) {
  const { payload } = data;
  const { navigate } = payload;
  const encodedData = yield call(handleEncodeJson, {
    encodeJSON: payload?.data,
  });
  console.log(payload, "payload  onsoplddddddd")
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  try {
    const profileSummary = yield select(
  (state) => state?.authReducer?.ProfileSummaryDetails
);  
    const candidateid = yield select(
      (state) => state?.authReducer?.candidateTokenDetails?.candidateid
    ) || profileSummary[0]?.candidateid;
    const result = yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_URL}/candidate/course/registraton/examdetails/${encodeURIComponent(
          EncryptFunction(candidateid)
        )}`,
        encodedData
      )
    );
    if (result) {
      yield delay(2000);
      // yield put({
      //   type: commonActions.SET_ALERT,
      //   payload: {
      //     status: result?.data?.statusCode == 200 ? "success" : "failed",
      //     show: true,
      //     message: result?.data?.message,
      //   },
      // });
      yield put({
        type: candidatesActions.GET_COURSE_FORM_DETAILS,
        payload: { courseid: payload?.data?.courseid },
      })
      yield put({
        type: candidatesActions.GET_COURSE_ACTIVE_TAB,
        payload: {
          data: {
            courseid: parseInt(payload?.data?.courseid),
            candidateid: parseInt(candidateid),
          },
        },
      });
    }
    if (result?.data?.statusCode === 200) {
      navigate(
        `/${sessionStorage.getItem("mhet_cnd_project")}/course-registration?page=${payload.nextPageName
        }`,
        {
          state: {
            courseid: payload?.data?.courseid,
            coursename: payload?.data?.coursename,
          },
        }
      );
            yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.statusCode === 200 ? "success" : "failed",
          show: true,
          message: result?.data?.message,
        },
      });
      // window.location.reload();
    } else if (result?.data?.statusCode === 410) {
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.statusCode === 410 && "failed",
          show: true,
          message: result?.data?.message,
        },
      });
    } else if(result?.data?.statusCode === 450){
        yield put({
        type: commonActions.SHOW_CLOSE_TAB_MODAL,
        payload: true,
      });
    }else if(result?.data?.statusCode === 451){
       yield put({
        type: authActions.SET_APPAR_MANDATORY_DIALOG,
        payload : true
       })
    }
     yield delay(2000);
     yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: null,
          show: false,
          message: null,
        },
      });
  } catch (err) {
    yield call(InternalError, err)


  }
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};
const otbsCourseExamdetailsCreation = function* (data) {
  const { payload } = data;
  const { navigate } = payload;
  const encodedData = yield call(handleEncodeJson, {
    encodeJSON: payload?.data,
  });
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.post(`${process.env.REACT_APP_API_URL}/backoffice/venuedata/scheduler`, encodedData)
    );
    if (result) {
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.statusCode === 200 ? "success" : "failed",
          show: true,
          message: result?.data?.message,
        },
      });

      // yield delay(2000);
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: null,
          show: false,
          message: null,
        },
      });
    }
    if (result?.data?.statusCode === 200) {
      yield ({
        type: candidatesActions.GET_COURSE_FORM_DETAILS,
        payload: { courseid: payload?.data?.courseid },
      })
      yield put({
        type: candidatesActions.GET_COURSE_ACTIVE_TAB,
        payload: {
          data: {
            courseid: payload?.data?.courseid,
          },
        },
      });
      yield put({
        type: candidatesActions.GET_CURRENT_VENUE_DETAILS,
        payload: {
          courseid: payload?.data?.courseid,
          candidateid: payload?.data?.candidateid,
        },
      });
      // navigate(
      //   `/${sessionStorage.getItem("mhet_cnd_project")}/course-registration?page=${
      //     payload.nextPageName
      //   }`,
      //   {
      //     state: {
      //       courseid: payload?.data?.courseid,
      //       coursename: payload?.data?.coursename,
      //     },
      //   }
      // );
      // window.location.reload();
      navigate(
        `/${sessionStorage.getItem(
          "mhet_cnd_project"
        )}/course-registration?page=${payload.nextPageName
        }`,
        {
          state: {
            courseid: payload?.data?.courseid,
            coursename: payload?.data?.coursename,
          },
        }
      );
    } else if(result?.data?.statusCode === 450){
        yield put({
        type: commonActions.SHOW_CLOSE_TAB_MODAL,
        payload: true,
      });
    }
  } catch (err) {
    yield call(InternalError, err)


  }
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};
const getVenueDetails = function* (data) {
  const { payload } = data;
  const { setAvailable, navigate } = payload;
  const encodedData = yield call(handleEncodeJson, {
    encodeJSON: payload?.data,
  });
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_URL}/backoffice/venuedata/venue-allocation/${data?.payload?.courseid}/${data?.payload?.candidateid}/${data?.payload?.validtime}/${data?.payload?.venueid}`
      )
    );
    if (result) {
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.statusCode === 200 ? "success" : "failed",
          show: true,
          message: result?.data?.message,
        },
      });
      yield delay(2000);
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: null,
          show: false,
          message: null,
        },
      });
    }
    if (result?.data?.statusCode === 400) {
      setAvailable(true);
    }

  } catch (err) {
    yield call(InternalError, err)


  }
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};

const getSeatAvailibility = function* (data) {
  const { payload } = data;
  const { setAvailable, navigate } = payload;
  const encodedData = yield call(handleEncodeJson, {
    encodeJSON: payload?.data,
  });
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_URL}/backoffice/venuedata/venue-allocation/seat-available/${data?.payload?.courseid}/${data?.payload?.venueid}`
      )
    );
    console.log(result?.data,"result consoleddddddd for otbs")
    if (result?.data?.statusCode === 200) {
      yield put({
        type: candidatesActions.SET_SEAT_AVAILIBILITY, payload: result?.data?.result
      })
      // yield put({
      //   type: commonActions.SET_ALERT,
      //   payload: {
      //     status: result?.data?.statusCode === 200 ? "success" : "failed",
      //     show: true,
      //     message: result?.data?.message,
      //   },
      // });
      // yield delay(2000);
      // yield put({
      //   type: commonActions.SET_ALERT,
      //   payload: {
      //     status: null,
      //     show: false,
      //     message: null,
      //   },
      // });
    }
    // if (result?.data?.statusCode === 400) {
    //   setAvailable(true);
    // }

  } catch (err) {
    yield put({
    type: candidatesActions.SET_SEAT_AVAILIBILITY, payload: null
  })
    yield call(InternalError, err)

  }
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};


const getFreecourseVenueDetails = function* (data) {
  const { payload } = data;
  const { navigate, dispatch } = payload;
  const encodedData = yield call(handleEncodeJson, {
    encodeJSON: payload?.data,
  });
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_URL}/backoffice/venuedata/venue-allocation/${data?.payload?.courseid}/${data?.payload?.candidateid}/${data?.payload?.validtime}/${data?.payload?.venueid}`
      )
    );
    // if (result) {
    //   yield put({
    //     type: commonActions.SET_ALERT,
    //     payload: {
    //       status: result?.data?.statusCode === 200 ? "success" : "failed",
    //       show: true,
    //       message: result?.data?.message,
    //     },
    //   });
    //   yield delay(2000);
    //   yield put({
    //     type: commonActions.SET_ALERT,
    //     payload: {
    //       status: null,
    //       show: false,
    //       message: null,
    //     },
    //   });
    // }
    if (result?.data?.statusCode === 200) {
      yield put({
        type: candidatesActions.FREE_REGISTRATION,
        payload: {
          courseid: data?.payload?.courseid,
          candidateid: data?.payload?.candidateid,
        },
      });
      navigate(
        `/${sessionStorage.getItem(
          "mhet_cnd_project"
        )}/course-registration?page=printapplication&&c_data=${EncryptObjectFunction(
          {
            courseid: data?.payload?.courseid,
            coursename: data?.payload?.coursename,
          }
        )}`,
        {
          state: {
            courseid: data?.payload?.courseid,
            coursename: data?.payload?.coursename,
          },
        }
      );
    } else {
      navigate(
        `/${sessionStorage.getItem(
          "mhet_cnd_project"
        )}/venue-allocation?courseid=${EncryptFunction(
          data?.payload?.courseid
        )}&coursename=${encodeURIComponent(data?.payload?.coursename)}`,
        {
          state: {
            courseid: data?.payload?.courseid,
            coursename: data?.payload?.coursename,
          },
        }
      );
      // dispatch({
      //   type: candidatesActions.FREE_REGISTRATION,
      //   payload: {
      //     courseid: data?.payload?.courseid,
      //     candidateid: data?.payload?.candidateid,
      //   },
      // });
    }
  } catch (err) {
    yield call(InternalError, err)


  }
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};

const getAllCourseRegistrationDetails = function* (data) {
  const { payload } = data;
  // yield put({ type: authActions.CANDIDATE_TOKEN_VERIFY });
  // yield delay(2000);
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  const candidateid = yield select(
    (state) => state?.authReducer?.candidateTokenDetails?.candidateid
  );
  try {
    const result = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_URL}/candidate/course/registraton/${encodeURIComponent(
          EncryptFunction(candidateid)
        )}/${encodeURIComponent(EncryptFunction(payload?.courseid))}`
      )
    );
    const decryptedData = yield call(handleDecodeJSON, {
      decodeJSON: result?.data?.result,
    });
    yield put({
      type: candidatesActions.SET_COURSE_REGISTRATION_DETAILS,
      payload: result?.data?.statusCode === 200 ? decryptedData : [],
    });
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
  } catch (err) {
    yield call(InternalError, err)
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
  } finally {
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
  }
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};

function* getCourseAddressDetails(data) {
  const { payload } = data;
  try {
    const result = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_URL}/candidate/course/registraton/courseaddressdetails/${encodeURIComponent(
          EncryptFunction(payload?.candidateid)
        )}/${encodeURIComponent(EncryptFunction(payload?.courseid))}`
      )
    );

    const decryptedData = yield call(handleDecodeJSON, {
      decodeJSON: result?.data?.result,
    });
    // console.log(decryptedData,"address>>>courseaddressdetails")
    const { statusCode } = result?.data || {};

    yield put({
      type: candidatesActions.SET_COURSE_ADDRESS_DETAILS,
      payload: statusCode === 200 ? decryptedData : [],
    });

    if (statusCode === 200 && decryptedData?.length > 0) {
      const [{ pstateid, pdistrictid, ptalukaid, cstateid, cdistrictid, ctalukaid }] =
        decryptedData;
if(payload?.loadMaster){
      // 🔹 First get states
      yield put({ type: masterActions.GET_STATE });
      yield take(masterActions.SET_STATE); // wait until state options are stored

      if (pstateid) {
        yield put({
          type: masterActions.GET_DISTRICT_FOR_COURSE,
          payload: { type: "parmanent", stateid: pstateid },
        });
        yield take(masterActions.SET_DISTRICT_FOR_COURSE); // wait for district list
      }

      if (pdistrictid) {
        yield put({
          type: masterActions.GET_TALUKA_FOR_COURSE,
          payload: { type: "parmanent", districtid: pdistrictid },
        });
        yield take(masterActions.SET_TALUKA_FOR_COURSE);
      }

      if (ptalukaid) {
        yield put({
          type: masterActions.GET_VILLAGE_FOR_COURSE,
          payload: { type: "parmanent", talukaid: ptalukaid },
        });
        yield take(masterActions.SET_VILLAGE_FOR_COURSE);
      }

      // same for correspondence
      if (cstateid) {
        yield put({
          type: masterActions.GET_DISTRICT_FOR_COURSE,
          payload: { type: "corespondence", stateid: cstateid },
        });
        yield take(masterActions.SET_DISTRICT_FOR_COURSE);
      }

      if (cdistrictid) {
        yield put({
          type: masterActions.GET_TALUKA_FOR_COURSE,
          payload: { type: "corespondence", districtid: cdistrictid },
        });
        yield take(masterActions.SET_TALUKA_FOR_COURSE);
      }

      if (ctalukaid) {
        yield put({
          type: masterActions.GET_VILLAGE_FOR_COURSE,
          payload: { type: "corespondence", talukaid: ctalukaid },
        });
        yield take(masterActions.SET_VILLAGE_FOR_COURSE);
      }
      }
    }
  } catch (err) {
    yield call(InternalError, err);
  }
}

const getAllCourse = function* (data) {
  // yield put({ type: authActions.CANDIDATE_TOKEN_VERIFY });
  // yield delay(200);
  const {payload} = data;
  const profileSummary = yield select(
  (state) => state?.authReducer?.ProfileSummaryDetails
); 
  const candidateid = yield select(
    (state) => state?.authReducer?.candidateTokenDetails?.candidateid
  ) || payload?.candidateid || profileSummary[0]?.candidateid;
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_URL}/candidate/course/${encodeURIComponent(
          EncryptFunction(candidateid)
        )}`
      )
    );
    const decryptedData = yield call(handleDecodeJSON, {
      decodeJSON: result?.data?.result,
    });

    yield put({
      type: candidatesActions.SET_ALL_COURSE_LIST,
      payload: {
        all: result?.data?.statusCode === 200 ? decryptedData : [],
        filtered: result?.data?.statusCode === 200 ? decryptedData : [],
      },
    });
  } catch (err) {
    yield call(InternalError, err)


  }
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};

const getCourseTab = function* (data) {
  const { payload } = data;
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
    let cacheKey = `form_tabs_${payload?.data?.courseid}`;
    const cachedData = yield call(getCacheWithExpiry, cacheKey);
    if (cachedData) {
      yield put({
        type: candidatesActions.SET_COURSE_TAB,
        payload: cachedData,
      });
    } else {
      const result = yield call(() =>
        axios.get(
          `${process.env.REACT_APP_API_URL}/master/coursemanagement/form/tab/${payload?.data?.courseid}`
        )
      );
      if (result) {
        yield put({
          type: candidatesActions.SET_COURSE_TAB,
          payload: result?.data?.statusCode === 200 ? result?.data?.result : [],
        });
        yield call(setCacheWithExpiry, cacheKey, result?.data?.result, cacheTTL);
        yield call(ExternalError, result)
      }
    }
  } catch (err) {
    yield call(InternalError, err)
  } finally {
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
  }
};

const getMasterFields = function* (data) {
  const { payload } = data;
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
    let cacheKey = `form_fields_${payload?.data?.courseid}`;
    const cachedData = yield call(getCacheWithExpiry, cacheKey);

    if (cachedData) {
      yield put({
        type: candidatesActions.SET_MASTER_FIELDS,
        payload: cachedData,
      });
    } else {
      const result = yield call(() =>
        axios.get(
          `${process.env.REACT_APP_API_URL}/master/coursemanagement/form/field/${payload?.data?.courseid}`
        )
      );

      if (result) {
        yield put({
          type: candidatesActions.SET_MASTER_FIELDS,
          payload: result?.data?.result,
        });
        yield call(setCacheWithExpiry, cacheKey, result?.data?.result, cacheTTL);
        yield call(ExternalError, result)
      }
    }
  } catch (err) {
    yield call(InternalError, err);
  }
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};



const getCourseRegistrationActiveTab = function* (data) {
  // yield put({ type: authActions.CANDIDATE_TOKEN_VERIFY });
  yield delay(2000);
  // yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
const profileSummary = yield select(
  (state) => state?.authReducer?.ProfileSummaryDetails
);  
const candidateid = yield select(
    (state) => state?.authReducer?.candidateTokenDetails?.candidateid
  ) || profileSummary[0]?.candidateid;
  const { payload } = data;
  try {
    const result = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_URL}/candidate/course/registraton/active-tab/${encodeURIComponent(
          EncryptFunction(candidateid)
        )}/${encodeURIComponent(EncryptFunction(payload?.data?.courseid))}`
      )
    );
    const decryptedData = yield call(handleDecodeJSON, {
      decodeJSON: result?.data?.result,
    });


    yield put({
      type: candidatesActions.SET_COURSE_ACTIVE_TAB,
      payload: result?.data?.statusCode === 200 ? decryptedData[0] : [],
    });
    // yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
  } catch (err) {
    // yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
    // yield call(InternalError, err);
  }
  // yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};

const getCourseApplicantId = function* (data) {
  // yield put({ type: authActions.CANDIDATE_TOKEN_VERIFY });
  const candidateid = yield select(
    (state) => state?.authReducer?.candidateTokenDetails?.candidateid
  );
  // yield delay(200);

  const { payload } = data;
  try {
    const result = yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_URL}/candidate/course/registraton/applicantid/${encodeURIComponent(
          EncryptFunction(candidateid)
        )}/${encodeURIComponent(EncryptFunction(payload?.courseid))}`
      )
    );
    // , {
    //   courseid: payload?.courseid,
    //   candidateid: payload?.candidateid,
    // }
    const decryptedData = yield call(handleDecodeJSON, {
      decodeJSON: result?.data?.result,
    });
    yield put({
      type: candidatesActions.SET_COURSE_APPLICANTID,
      payload: result?.data?.statusCode === 200 ? decryptedData : {},
    });
    yield call(ExternalError, result)
  } catch (err) {
    yield call(InternalError, err)



  }
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};

const getCourseStatus = function* (data) {
  const { payload } = data;
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
    // const candidateid = yield select(
    //   (state) => state?.authReducer?.candidateTokenDetails?.candidateid
    // );
    const result = yield call(() =>
      // axios.post(
      //   `${process.env.REACT_APP_API_URL}/candidate/course/course-status/${encodeURIComponent(
      //     EncryptFunction(payload?.candidateid)
      //   // )}/${encodeURIComponent(EncryptFunction(payload?.courseid))}`
      //   )}`
      // )
      axios.post(
        `${process.env.REACT_APP_API_URL}/candidate/course/course-status`,
        {
          candidateid: encodeURIComponent(
            EncryptFunction(payload?.candidateid)
          ),
          courseid: encodeURIComponent(EncryptFunction(payload?.courseid))
        }
      )
    );
    const decryptedData = yield call(handleDecodeJSON, {
      decodeJSON: result?.data?.result,
    });
    yield put({
      type: candidatesActions.SET_COURSE_STATUS,
      payload: result?.data?.statusCode === 200 ? decryptedData[0] : [],
    });
    // yield call(ExternalError, result)
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
  } catch (err) {
    // yield call(InternalError, err)
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
  }
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};

// const getIsPaid = function* (data) {
//   const { payload } = data;
//   yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
//   try {
//     const candidateid = yield select(
//       (state) => state?.authReducer?.candidateTokenDetails?.candidateid
//     );
//     const result = yield call(() =>
//       axios.post(
//         `${process.env.REACT_APP_API_URL}/candidate/course/ispaid/${encodeURIComponent(
//           EncryptFunction(candidateid)
//         )}`,
//         {
//           candidateid: payload?.candidateid,
//           courseid: payload?.courseid,
//         }
//       )
//     );
//     const decryptedData = yield call(handleDecodeJSON, {
//       decodeJSON: result?.data?.result,
//     });

//     yield put({
//       type: candidatesActions.SET_IS_PAID,
//       payload: result?.data?.statusCode === 200 ? decryptedData : [],
//     });
//   } catch (err) {
//   }
//   yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
// };
const getIsPaid = function* (data) {
  const { payload } = data;
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });

  try {
    const profileSummary = yield select(
  (state) => state?.authReducer?.ProfileSummaryDetails
);  
    const candidateid = yield select(
      (state) => state?.authReducer?.candidateTokenDetails?.candidateid
    ) || profileSummary[0]?.candidateid;

    const result = yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_URL}/candidate/course/ispaid/${encodeURIComponent(
          EncryptFunction(payload?.candidateid)
        )}/${encodeURIComponent(EncryptFunction(payload?.courseid))}`
      )
    );

    const decryptedData = yield call(handleDecodeJSON, {
      decodeJSON: result?.data?.result,
    });

    yield put({
      type: candidatesActions.SET_IS_PAID,
      payload: result?.data?.statusCode === 200 ? decryptedData : [],
    });
    yield call(ExternalError, result)
  } catch (err) {
    yield call(InternalError, err)



  }

  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};

const getPaymentReceiptList = function* (data) {
  const { payload } = data;
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_URL}/candidate/paymentReceipt/${encodeURIComponent(
          EncryptFunction(payload?.candidateid)
        )}`
      )
    );
    const decryptedData = yield call(handleDecodeJSON, {
      decodeJSON: result?.data?.result,
    });
    yield put({
      type: candidatesActions.SET_PAYMENT_RECEIPT_LIST,
      payload: result?.data?.statusCode === 200 ? decryptedData : [],
    });
  } catch (err) {
    yield call(InternalError, err)


  }
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};

const getExamState = function* (data) {
  const { payload } = data;
  try {
    const result = yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_URL}/candidate/course/registraton/exam-state`,
        payload?.data
      )
    );
    yield put({
      type: candidatesActions.SET_EXAM_STATE,
      payload: result?.data?.statusCode === 200 ? result?.data?.result : [],
    });
    yield call(ExternalError, result)
  } catch (err) {
    yield call(InternalError, err)



  }
};

const getExamDistrict = function* (data) {
  const { payload } = data;
  try {
    const result = yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_URL}/candidate/course/registraton/exam-district`,
        payload?.data
      )
    );
    yield put({
      type: candidatesActions.SET_EXAM_DISTRICT,
      payload:
        result?.data?.statusCode === 200
          ? { all: result?.data?.result, filtered: [] }
          : { all: [], filtered: [] },
    });
    yield call(ExternalError, result)
  } catch (err) {
    yield call(InternalError, err)



  }
};

const getExamLanguage = function* (data) {
  const { payload } = data;
  try {
    const result = yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_URL}/candidate/course/registraton/exam-language`,
        payload?.data
      )
    );
    yield put({
      type: candidatesActions.SET_EXAM_LANGUAGE,
      payload: result?.data?.statusCode === 200 ? result?.data?.result : [],
    });
    yield call(ExternalError, result)
  } catch (err) {
    yield call(InternalError, err)



  }
};

const getCourseFormDetails = function* (data) {
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  const { payload } = data;

  const candidateid = yield select(
    (state) => state?.authReducer?.candidateTokenDetails?.candidateid
  );
  try {
    const result = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_URL}/candidate/course/registraton/info/${encodeURIComponent(
          EncryptFunction(candidateid)
        )}/${encodeURIComponent(EncryptFunction(payload?.courseid))}`
      )
    );

    const decryptedData = yield call(handleDecodeJSON, {
      decodeJSON: result?.data?.result,
    });
    // console.log("decryptedData candidate/course/registraton/info>>>>>",decryptedData)
    yield put({
      type: candidatesActions.SET_COURSE_FORM_DETAILS,
      payload: result?.data?.statusCode === 200 ? decryptedData : [],
    });
    // if (decryptedData[0]?.pstateid) {
    //   yield put({
    //     type: masterActions.GET_DISTRICT,
    //     payload: decryptedData[0]?.pstateid,
    //   });
    // }
    // if (decryptedData[0]?.pdistrictid) {
    //   yield put({
    //     type: masterActions.GET_TALUKA,
    //     payload: decryptedData[0]?.pdistrictid,
    //   });
    // }
    // if (decryptedData[0]?.ptalukaid) {
    //   yield put({
    //     type: masterActions.GET_VILLAGE,
    //     payload: decryptedData[0]?.ptalukaid,
    //   });
    // }
    // if (decryptedData[0]?.cstateid) {
    //   yield put({
    //     type: masterActions.GET_DISTRICT,
    //     payload: decryptedData[0]?.cstateid,
    //   });
    // }
    // if (decryptedData[0]?.cdistrictid) {
    //   yield put({
    //     type: masterActions.GET_TALUKA,
    //     payload: decryptedData[0]?.cdistrictid,
    //   });
    // }
    // if (decryptedData[0]?.ctalukaid) {
    //   yield put({
    //     type: masterActions.GET_VILLAGE,
    //     payload: decryptedData[0]?.ctalukaid,
    //   });
    //   if (decryptedData[0]?.stateid) {
    //     yield put({
    //       type: masterActions.GET_DISTRICT,
    //       payload: decryptedData[0]?.stateid,
    //     });
    //   }
    // }
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
  } catch (err) {
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
    yield call(InternalError, err);
  } finally {
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
  }
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};

const getCurrentCourse = function* (data) {
  const { payload } = data;
  try {
    const profileSummary = yield select(
  (state) => state?.authReducer?.ProfileSummaryDetails
);  
    const candidateid = yield select(
      (state) => state?.authReducer?.candidateTokenDetails?.candidateid
    ) || profileSummary[0]?.candidateid;
    const result = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_URL}/candidate/course/singlecourse/${encodeURIComponent(
          EncryptFunction(payload?.courseid)
        )}/${encodeURIComponent(EncryptFunction(candidateid))}`
      )
    );
    const decryptedData = yield call(handleDecodeJSON, {
      decodeJSON: result?.data?.result,
    });

    yield put({
      type: candidatesActions.SET_CURRENT_COURSE,
      payload: result?.data?.statusCode === 200 ? decryptedData : [],
    });
  } catch (err) {
    yield call(InternalError, err)


  }
};

const updatePreviewandPaymentStatus = function* (data) {
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  const { payload } = data;
  const { navigate, coursename, setEligibility, setFreecourse } = payload;
    yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  try {
    const encryptedData = yield call(handleEncodeJson, {
      encodeJSON: payload?.data,
    });
    const result = yield call(() =>
      axios.put(
        `${process.env.REACT_APP_API_URL}/candidate/course/registraton/preview`,
        encryptedData
      )
    );

    if (result?.data?.statusCode === 200) {
      // yield put({
      //   type: candidatesActions.GET_COURSE_ACTIVE_TAB,
      //   payload: {
      //     data: {
      //       courseid: parseInt(payload?.data?.courseid),
      //       candidateid: parseInt(payload?.data?.candidateid),
      //     },
      //   },
      // });
      if (result?.data?.isTimeOver) {
        navigate(
          `/${sessionStorage.getItem(
            "mhet_cnd_project"
          )}/course-registration?page=examinationdetails&courseid=${EncryptFunction(
            payload?.data?.courseid
          )}&coursename=${encodeURIComponent(coursename)}`,
          {
            state: {
              courseid: payload?.data?.courseid,
              coursename: coursename,
            },
          }
        );
              yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status:  "failed",
          show: true,
          message: "Your seat reservation has been cancelled as your time is over.",
        },
      });
      yield delay(4000);
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: null,
          show: false,
          message: null,
        },
      });
      } else {
        navigate(
          `/${sessionStorage.getItem(
            "mhet_cnd_project"
          )}/course-registration?page=applicationfee&&c_data=${EncryptObjectFunction(
            { ...payload?.data, coursename: coursename }
          )}`,
          {
            state: {
              courseid: payload?.data?.courseid,
              coursename: coursename,
            },
          }
        );
      }

      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.statusCode === 200 ? "success" : "failed",
          show: true,
          message: result?.data?.message,
        },
      });
      yield delay(2000);
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: null,
          show: false,
          message: null,
        },
      });
    } else if (result?.data?.statusCode === 201) {

      const decryptedData = yield call(handleDecodeJSON, {
        decodeJSON: result.data.result,
      });

      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.statusCode === 201 ? "failed" : "success",
          show: true,
          message: decryptedData?.message,
          details: decryptedData?.details,
        },
      });

      yield delay(2000);
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: null,
          show: false,
          message: null,
        },
      });

      setEligibility(true);

      yield put({
        type: candidatesActions.SET_ELIGIBILITY_DETAILS,
        payload: decryptedData?.details || [],
      });
    } else if(result?.data?.statusCode === 450){
        yield put({
        type: commonActions.SHOW_CLOSE_TAB_MODAL,
        payload: true,
      });
    }else if(result?.data?.statusCode === 451){
       yield put({
        type: authActions.SET_APPAR_MANDATORY_DIALOG,
        payload : true
       })
    }
    if (result?.data?.statusCode === 700) {
      setFreecourse(true);
    }
  } catch (err) {
    yield call(InternalError, err)


  }
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};

const createPrintLog = function* (data) {
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  const { payload } = data;
  try {
    const encryptedData = yield call(handleEncodeJson, {
      encodeJSON: payload?.data,
    });
    yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_URL}/candidate/course/registraton/print-log`,
        encryptedData
      )
    );

  } catch (err) {
    yield call(InternalError, err)



  }
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};

const updateCourseDetails = function* (data) {
  const { payload } = data;
  const {
    
    isExtraFee,
    coursename,
    subjectgroup,
    photofilename,
    signfilename,
  } = payload?.data;
  const {navigate, edit} = payload
    yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  try {
    const formData = new FormData();

    if (payload.data && typeof payload.data === "object") {
      Object.entries(payload.data).forEach(([key, value]) => {
        if(key != 'photofilename' && key != 'signfilename'){
          formData.append(key, value);
        }
      });
    } else {
      console.error("Invalid payload.data structure", payload.data);
    }
    const photoFile = photofilename
      ? new File([photofilename], `${payload?.data?.candidateid}_photo.jpeg`, {
        type: "image/jpeg",
      })
      : null;
    const signFile = signfilename
      ? new File(
        [signfilename],
        `${payload?.data?.candidateid}_signature.jpeg`,
        { type: "image/jpeg" }
      )
      : null;

    formData.append("photofilename", photoFile || "");
    formData.append("signfilename", signFile || "");
    formData.append("photourl", photoFile ? "" : payload?.data?.photourl);
    formData.append("signurl", signFile ? "" : payload?.data?.signurl);

    const result = yield call(() =>
      axios.put(
        `${process.env.REACT_APP_API_URL}/candidate/course/registraton/edit/${encodeURIComponent(
          EncryptFunction(payload?.data?.candidateid)
        )}/${encodeURIComponent(EncryptFunction(payload?.data?.courseid))}`,
        formData
      )
    );
    if (result?.data?.statusCode === 200) {
        yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
      let encryptedData = {
        courseid: payload?.data?.courseid,
        isExtraFee: isExtraFee,
        coursename: coursename,
        edit: edit,
        subjectgroup: subjectgroup,
      };
      if(result?.data?.result?.amount > 0){
                yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
        yield put({
          type: candidatesActions.SET_EDITING_AMOUNT, payload: result?.data?.result?.amount,
        })
        yield put({
          type: commonActions.SHOW_PAYMENT_CONFIRMATION_MODAL, payload: true
        });

      }else{
                yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
          navigate(
        `/${sessionStorage.getItem(
          "mhet_cnd_project"
        )}/course-registration?page=preview&&c_data=${EncryptObjectFunction(
          encryptedData
        )}`
      );
      }
      // navigate(
      //   `/${sessionStorage.getItem(
      //     "mhet_cnd_project"
      //   )}/course-registration?page=preview&&c_data=${EncryptObjectFunction(
      //     encryptedData
      //   )}`
      // );
    }
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: result?.data?.statusCode === 200 ? "success" : "failed",
        show: true,
        message: result?.data?.message,
      },
    });
    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: null,
        show: false,
        message: null,
      },
    });

    yield put({
      type: commonActions.SET_SHOW_MODAL,
      payload: {
        show: false,
        type: "ELG",
        method: "eligibilitycriteriadetails",
      },
    });
    // yield put({
    //   type: commonActions.SET_UPDATE_DETAILS, payload: false
    // })
  } catch (err) {
            yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
    yield call(InternalError, err)
  }
          yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};

const uploadScribe1Photo = function* (data) {
  const { payload } = data;
  const {
    courseid,
    candidateid,
    scribe1photo,
    coursename,
    scribeType,
  } = payload;
  const {navigate} = payload
  try {
    const formData = new FormData();

    if (payload.data && typeof payload.data === "object") {
      Object.entries(payload.data).forEach(([key, value]) => {
        formData.append(key, value);
      });
    } else {
      console.error("Invalid payload.data structure", payload.data);
    } 

    formData.append("courseid", courseid);
    formData.append("candidateid", candidateid);
    formData.append("scribe1photo", scribe1photo);

    const result = yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_URL}/candidate/course/registraton/scribe-details/uploads`,
        formData
      )
    );
    if (result?.data?.statusCode === 200) {
      //       navigate(
      //   `/${sessionStorage.getItem(
      //     "mhet_cnd_project"
      //   )}/course-registration?page=domicileandcategorydetails&courseid=${courseid}&coursename=${coursename}&scribetype=${scribeType}&gateway=sandbox&type=digilocker&client_id=digilocker_FcIfbswwwDDdhxEPtxQo&status=success`
      // );


      // window.location.reload();

          yield put({
      type: candidatesActions.GET_SCRIBE_DETAILS,
      payload: {
        candidateid,
        courseid,
      },
    });
          yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: result?.data?.statusCode === 200 ? "success" : "failed",
        show: true,
        message: result?.data?.message,
      },
    });


    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: null,
        show: false,
        message: null,
      },
    });

    yield put({
      type: commonActions.SET_SHOW_MODAL,
      payload: {
        show: false,
        type: "ELG",
        method: "eligibilitycriteriadetails",
      },
    });
    }


  } catch (err) {
    yield call(InternalError, err)


  }
};

const uploadScribe2Photo = function* (data) {
  const { payload } = data;
  const {
    courseid,
    candidateid,
    scribe2photo,
    coursename,
    scribeType,
  } = payload;
  const {navigate} = payload
  try {
    const formData = new FormData();

    if (payload.data && typeof payload.data === "object") {
      Object.entries(payload.data).forEach(([key, value]) => {
        formData.append(key, value);
      });
    } else {
      console.error("Invalid payload.data structure", payload.data);
    } 

    formData.append("courseid", courseid);
    formData.append("candidateid", candidateid);
    formData.append("scribe2photo", scribe2photo);

    const result = yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_URL}/candidate/course/registraton/scribe-details/uploads`,
        formData
      )
    );
    if (result?.data?.statusCode === 200) {
      yield put({
      type: candidatesActions.GET_SCRIBE_DETAILS,
      payload: {
        candidateid,
        courseid,
      },
    });

      // window.location.reload();
          yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: result?.data?.statusCode === 200 ? "success" : "failed",
        show: true,
        message: result?.data?.message,
      },
    });
    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: null,
        show: false,
        message: null,
      },
    });

    yield put({
      type: commonActions.SET_SHOW_MODAL,
      payload: {
        show: false,
        type: "ELG",
        method: "eligibilitycriteriadetails",
      },
    });
    }


  } catch (err) {
    yield call(InternalError, err)


  }
};

const uploadScribe1Document = function* (data) {
  const { payload } = data;
  const {
    courseid,
    candidateid,
    scribe1document,
    coursename,
    scribeType,
  } = payload;
  const {navigate} = payload
  try {
    const formData = new FormData();

    if (payload.data && typeof payload.data === "object") {
      Object.entries(payload.data).forEach(([key, value]) => {
        formData.append(key, value);
      });
    } else {
      console.error("Invalid payload.data structure", payload.data);
    } 

    formData.append("courseid", courseid);
    formData.append("candidateid", candidateid);
    formData.append("scribe1document", scribe1document);

    const result = yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_URL}/candidate/course/registraton/scribe-details/uploads`,
        formData
      )
    );
    if (result?.data?.statusCode === 200) {
      //       navigate(
      //   `/${sessionStorage.getItem(
      //     "mhet_cnd_project"
      //   )}/course-registration?page=domicileandcategorydetails&courseid=${courseid}&coursename=${coursename}&scribetype=${scribeType}&gateway=sandbox&type=digilocker&client_id=digilocker_FcIfbswwwDDdhxEPtxQo&status=success`
      // );
      // window.location.reload();
             yield put({
      type: candidatesActions.GET_SCRIBE_DETAILS,
      payload: {
        candidateid,
        courseid,
      },
    });
          yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: result?.data?.statusCode === 200 ? "success" : "failed",
        show: true,
        message: result?.data?.message,
      },
    });
    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: null,
        show: false,
        message: null,
      },
    });

    yield put({
      type: commonActions.SET_SHOW_MODAL,
      payload: {
        show: false,
        type: "ELG",
        method: "eligibilitycriteriadetails",
      },
    });
    }
    // window.location.reload();
  } catch (err) {
    yield call(InternalError, err)


  }
};

const uploadScribe2Document = function* (data) {
  const { payload } = data;
  const {
    courseid,
    candidateid,
    scribe2document,
    coursename,
    scribeType,
  } = payload;
  const {navigate} = payload
  try {
    const formData = new FormData();

    if (payload.data && typeof payload.data === "object") {
      Object.entries(payload.data).forEach(([key, value]) => {
        formData.append(key, value);
      });
    } else {
      console.error("Invalid payload.data structure", payload.data);
    } 

    formData.append("courseid", courseid);
    formData.append("candidateid", candidateid);
    formData.append("scribe2document", scribe2document);

    const result = yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_URL}/candidate/course/registraton/scribe-details/uploads`,
        formData
      )
    );
    if (result?.data?.statusCode === 200) {
      //       navigate(
      //   `/${sessionStorage.getItem(
      //     "mhet_cnd_project"
      //   )}/course-registration?page=domicileandcategorydetails&courseid=${courseid}&coursename=${coursename}&scribetype=${scribeType}&gateway=sandbox&type=digilocker&client_id=digilocker_FcIfbswwwDDdhxEPtxQo&status=success`
      // );
      // window.location.reload();
       yield put({
      type: candidatesActions.GET_SCRIBE_DETAILS,
      payload: {
        candidateid,
        courseid,
      },
    });

          yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: result?.data?.statusCode === 200 ? "success" : "failed",
        show: true,
        message: result?.data?.message,
      },
    });
    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: null,
        show: false,
        message: null,
      },
    });

    yield put({
      type: commonActions.SET_SHOW_MODAL,
      payload: {
        show: false,
        type: "ELG",
        method: "eligibilitycriteriadetails",
      },
    });
    }
    // window.location.reload();
  } catch (err) {
    yield call(InternalError, err)


  }
};

const uploadScribe1QualifyDocument = function* (data) {
  const { payload } = data;
  const {
    courseid,
    candidateid,
    scribe1qualificationdocument,
    coursename,
    scribeType,
  } = payload;
  const {navigate} = payload
  try {
    const formData = new FormData();

    if (payload.data && typeof payload.data === "object") {
      Object.entries(payload.data).forEach(([key, value]) => {
        formData.append(key, value);
      });
    } else {
      console.error("Invalid payload.data structure", payload.data);
    } 

    formData.append("courseid", courseid);
    formData.append("candidateid", candidateid);
    formData.append("scribe1qualificationdocument", scribe1qualificationdocument);

    const result = yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_URL}/candidate/course/registraton/scribe-details/uploads`,
        formData
      )
    );
    if (result?.data?.statusCode === 200) {
      // window.location.reload();
        yield put({
      type: candidatesActions.GET_SCRIBE_DETAILS,
      payload: {
        candidateid,
        courseid,
      },
    });
          yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: result?.data?.statusCode === 200 ? "success" : "failed",
        show: true,
        message: result?.data?.message,
      },
    });
    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: null,
        show: false,
        message: null,
      },
    });

    yield put({
      type: commonActions.SET_SHOW_MODAL,
      payload: {
        show: false,
        type: "ELG",
        method: "eligibilitycriteriadetails",
      },
    });
    }
  } catch (err) {
    yield call(InternalError, err)
  }
};

const uploadScrib2QualifyDocument = function* (data) {
  const { payload } = data;
  const {
    courseid,
    candidateid,
    scribe2qualificationdocument,
    coursename,
    scribeType,
  } = payload;
  const {navigate} = payload
  try {
    const formData = new FormData();

    if (payload.data && typeof payload.data === "object") {
      Object.entries(payload.data).forEach(([key, value]) => {
        formData.append(key, value);
      });
    } else {
      console.error("Invalid payload.data structure", payload.data);
    } 

    formData.append("courseid", courseid);
    formData.append("candidateid", candidateid);
    formData.append("scribe2qualificationdocument", scribe2qualificationdocument);

    const result = yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_URL}/candidate/course/registraton/scribe-details/uploads`,
        formData
      )
    );
    if (result?.data?.statusCode === 200) {
      yield put({
      type: candidatesActions.GET_SCRIBE_DETAILS,
      payload: {
        candidateid,
        courseid,
      },
    });
          yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: result?.data?.statusCode === 200 ? "success" : "failed",
        show: true,
        message: result?.data?.message,
      },
    });
    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: null,
        show: false,
        message: null,
      },
    });

    yield put({
      type: commonActions.SET_SHOW_MODAL,
      payload: {
        show: false,
        type: "ELG",
        method: "eligibilitycriteriadetails",
      },
    });
    }
  } catch (err) {
    yield call(InternalError, err)
  }
};

const getIpAddress = function* () {
  try {
    const result = yield call(() =>
      axios.get(`${process.env.REACT_APP_API_URL}/candidate/course/registraton/ip`)
    );
    const decryptedData = yield call(handleEncodeJson, {
      decodeJSON: result?.data?.result,
    });

    yield put({
      type: candidatesActions.SET_IP_ADDRESS,
      payload: result?.data?.statusCode === 200 ? decryptedData : [],
    });
  } catch (err) {
    yield call(InternalError, err)


  }
};

const getOtbsVenueDetails = function* (data) {
  const { payload } = data;
  try {
    const result = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_URL}/backoffice/venuedata/otbsvenues/${payload?.courseid}`
      )
    );
    yield put({
      type: candidatesActions.SET_OTBS_VENUE_DETAILS,
      payload:
        result?.data?.statusCode === 200
          ? {
            States: result?.data?.stateResult,
            Districts: result?.data?.districtResult,
            Venues: result?.data?.result,
          }
          : {
            States: [],
            Districts: [],
            Venues: [],
          },
    });
  } catch (err) {
    yield call(InternalError, err)


  }
};

const getCurrentOtbsVenueDetails = function* (data) {
  const { payload } = data;
  // yield put({ type: authActions.CANDIDATE_TOKEN_VERIFY });
  // yield delay(200);


  try {
    const result = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_URL}/candidate/course/registraton/venue-allocation/${encodeURIComponent(
          EncryptFunction(payload?.candidateid)
        )}/${encodeURIComponent(EncryptFunction(payload?.courseid))}`
      )
    );

    if (result?.data?.statusCode == 200) {
      const decryptedData = yield call(handleDecodeJSON, {
        decodeJSON: result?.data?.result,
      });
      yield put({
        type: candidatesActions.SET_CURRENT_VENUE_DETAILS,
        payload: result?.data?.statusCode === 200 ? decryptedData : [],
      });
    }
  } catch (err) {
    yield call(InternalError, err)


  }
};

const otbsUpdateCourseExamdetailsCreation = function* (data) {
  const { payload } = data;
  const { navigate } = payload;
  // const encodedData = yield call(handleEncodeJson, { encodeJSON: payload?.data });
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.post(`${process.env.REACT_APP_API_URL}/backoffice/venuedata/scheduler`, payload?.data)
    );
    if (result) {
      yield put({
        type: candidatesActions.GET_COURSE_ACTIVE_TAB,
        payload: {
          data: {
            courseid: payload?.data?.courseid,
          },
        },
      });
      yield put({
        type: candidatesActions.GET_CURRENT_VENUE_DETAILS,
        payload: {
          courseid: payload?.data?.courseid,
          candidateid: payload?.data?.candidateid,
        },
      });
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.statusCode === 200 ? "success" : "failed",
          show: true,
          message: result?.data?.message,
        },
      });
      yield delay(2000);
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: null,
          show: false,
          message: null,
        },
      });
    }
    if (result?.data?.statusCode === 200) {
      navigate(
        `/${sessionStorage.getItem("mhet_cnd_project")}/course-registration?page=${payload.nextPageName
        }`,
        {
          state: {
            courseid: payload?.data?.courseid,
            coursename: payload?.data?.coursename,
          },
        }
      );
      // window.location.reload();
    }
  } catch (err) {
    yield call(InternalError, err)


  }
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};
const downloadBrochure = function* (data) {
  const { payload } = data;
  const { courseid, coursename } = payload;
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
    const profileSummary = yield select(
  (state) => state?.authReducer?.ProfileSummaryDetails
);  
    const candidateid = yield select(
      (state) => state?.authReducer?.candidateTokenDetails?.candidateid
    ) || profileSummary[0]?.candidateid;
    const result = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_URL}/candidate/course/brochure/${encodeURIComponent(
          EncryptFunction(courseid)
        )}/${encodeURIComponent(EncryptFunction(candidateid))}`
        //  {responseType: 'blob'}
      )
    );
    if (result?.data?.statusCode === 200 && result?.data?.data.trim() != "") {
      // yield call(downloadBase64, {
      //   base64: result?.data?.data,
      //   coursename: coursename,
      //   fileExtension: result?.data?.fileExtension,
      // });
      yield call(downloadFile, {
        url: result?.data?.data,
        coursename: coursename,
        fileExtension: result?.data?.fileExtension,
      });
      yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: "success",
          show: true,
          message: "Brochure Downloaded Successfully",
        },
      });
      // downloadBase64(result?.data, coursename);
    } else if (result?.data?.data.trim() == "") {
      yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: "failed",
          show: true,
          message: "Bochure not availabe for this course",
        },
      });
    } else {
      yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.statusCode === 200 ? "success" : "failed",
          show: true,
          message: result?.data?.message,
        },
      });
    }
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: null,
        show: false,
        message: null,
      },
    });
  } catch (err) {
    yield call(InternalError, err)


  }
};
const createDownloadLog = function* (data) {
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  const { payload } = data;
  try {
    const encryptedData = yield call(handleEncodeJson, {
      encodeJSON: payload?.data,
    });
    yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_URL}/candidate/course/registraton/admitcard-download-log`,
        encryptedData
      )
    );
  } catch (err) {
    yield call(InternalError, err)


  }
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};
const createscoreDownloadLog = function* (data) {
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  const { payload } = data;
  try {
    const encryptedData = yield call(handleEncodeJson, {
      encodeJSON: payload?.data,
    });
    yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_URL}/candidate/course/registraton/scorecard-download-log`,
        encryptedData
      )
    );
  } catch (err) {
    yield call(InternalError, err)


  }
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};

const AdmitAndScorecardViewButtonClick = function* (data) {
  const { payload } = data;

  // yield put({ type: authActions.CANDIDATE_TOKEN_VERIFY });
  // yield delay(200);
  try {
    const result = yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_URL}/candidate/course/registraton/admit-score-card-view-click/${encodeURIComponent(
          EncryptFunction(payload?.candidateid)
        )}/${encodeURIComponent(EncryptFunction(payload?.courseid))}`,
        {
          click: payload?.clickType,
          ipAddress: payload?.ipAddress,
        }
      )
    );
    yield call(ExternalError, result)
  } catch (err) {
    yield call(InternalError, err)



  }
};
const Freecourseregistration = function* (data) {
  const { payload } = data;

  // yield put({ type: authActions.CANDIDATE_TOKEN_VERIFY });
  // yield delay(200);
  try {
    const result = yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_URL}/candidate/course/registraton/free_course_reg/${encodeURIComponent(
          EncryptFunction(payload?.candidateid)
        )}/${encodeURIComponent(EncryptFunction(payload?.courseid))}`
      )
    );
    yield call(ExternalError, result)
  } catch (err) {
    yield call(InternalError, err)



  }
};
// const GetAdmitcardUrl = function* (data) {
//   const { payload } = data;
// const formData = new FormData();
// console.log(payload,"payload")
//     formData.append("docs", payload?.modifiedFile);

//   yield put({ type: authActions.CANDIDATE_TOKEN_VERIFY });
//   // yield delay(200);
//   try {
//       const response = axios.post(
//         `${process.env.REACT_APP_API_URL}/master/coursemanagement/docs/${payload?.candidateName}`,
//         formData
//       );
//       console.log(response,"response");
//       payload?.setfileUrl(response.data?.result)
//        yield put({
//       type: candidatesActions.SET_ADMITCARD_URL,
//       payload: response?.data?.statusCode === 200 ? response.data?.result : [],
//     });
//   } catch (err) {
//   }
// };
// const GetAdmitcardUrl = function* (data) {
//   const { payload } = data;
//   const { setfileUrl, setPreview,navigate,CourseId } = payload;
//   const formData = new FormData();

//   console.log(payload, setfileUrl, "payload");

//   formData.append("docs", payload?.modifiedFile);

//   yield put({ type: authActions.CANDIDATE_TOKEN_VERIFY });
//   // yield delay(200);

//   try {
//     const response = yield call(
//       axios.post,
//       `${process.env.REACT_APP_API_URL}/master/coursemanagement/docs/${payload?.candidateName}`,
//       formData
//     );

//     console.log(response, "response");

//     if (response?.data?.statusCode === 200) {
//       setfileUrl(response.data?.result);
//       setPreview(response.data?.result);
//       if (payload?.getUrl == 1) {
//         navigate(
//           `/${sessionStorage.getItem(
//             "mhet_cnd_project"
//           )}/admit-card?courseid=${EncryptFunction(CourseId)}`
//         );
//       } else {
//         navigate(
//           `/${sessionStorage.getItem(
//             "mhet_cnd_project"
//           )}/score-card?courseid=${EncryptFunction(CourseId)}`
//         );
//       }
//       yield put({
//         type: candidatesActions.SET_ADMITCARD_URL,
//         payload: response.data.result,
//       });
//     } else {
//       yield put({
//         type: candidatesActions.SET_ADMITCARD_URL,
//         payload: [],
//       });
//     }
//   } catch (err) {
//     console.error("Error uploading admit card:", err);
//   }
// };
const GetAdmitcardUrl = function* (data) {
  const { payload } = data;
  const { setfileUrl, setPreview, navigate, CourseId } = payload;
  const formData = new FormData();

  formData.append("docs", payload?.modifiedFile);

  // yield put({ type: authActions.CANDIDATE_TOKEN_VERIFY });
  // yield delay(200);

  try {
    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_API_URL}/master/coursemanagement/docs/${payload?.candidateName}`,
      formData,
      {
        responseType: 'blob' // Important for handling binary responses
      }
    );

    // Create a blob URL for the received file
    const blob = new Blob([response.data], { type: 'application/pdf' });
    const fileUrl = URL.createObjectURL(blob);

    setfileUrl(fileUrl);
    setPreview(fileUrl);

    if (payload?.getUrl == 1) {
      navigate(
        `/${sessionStorage.getItem("mhet_cnd_project")}/admit-card?courseid=${EncryptFunction(CourseId)}`
      );
    } else {
      navigate(
        `/${sessionStorage.getItem("mhet_cnd_project")}/score-card?courseid=${EncryptFunction(CourseId)}`
      );
    }

    yield put({
      type: candidatesActions.SET_ADMITCARD_URL,
      payload: fileUrl,
    });

  } catch (err) {
    yield call(InternalError, err)


  }
};

const getCoursePersonalInformationDetails = function* (data) {
  // console.log('called');
  
  const { payload } = data;
  yield put({ type: authActions.CANDIDATE_TOKEN_VERIFY });
  yield delay(1000);
  const candidateid = yield select(
    (state) => state?.authReducer?.candidateTokenDetails?.candidateid
  );
  try {
    const result = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_URL}/candidate/course/registraton/personal-information/${encodeURIComponent(
          EncryptFunction(candidateid)
        )}/${encodeURIComponent(EncryptFunction(payload?.courseid))}`
      )
    );
 
    
    const decryptedData = yield call(handleDecodeJSON, {
      decodeJSON: result?.data?.result,
    });
    // console.log(decryptedData, "personalk");
    yield put({
      type: candidatesActions.SET_COURSE_PERSONAL_INFORMATION_DETAILS,
      payload: result?.data?.statusCode === 200 ? decryptedData : [],
    });
  } catch (err) {}
  // yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};

const getCourseReservationDetails = function* (data) {
  const { payload } = data;
  yield put({ type: authActions.CANDIDATE_TOKEN_VERIFY });
  yield delay(1000);
  const candidateid = yield select(
    (state) => state?.authReducer?.candidateTokenDetails?.candidateid
  );
  try {
    const result = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_URL}/candidate/course/registraton/reservation-details/${encodeURIComponent(
          EncryptFunction(candidateid)
        )}/${encodeURIComponent(EncryptFunction(payload.courseid))}`
      )
    );
    const decryptedData = yield call(handleDecodeJSON, {
      decodeJSON: result?.data?.result,
    });
    yield put({
      type: candidatesActions.SET_COURSE_RESERVATION_DETAILS,
      payload: result?.data?.statusCode === 200 ? decryptedData : [],
    });
  } catch (err) {}
};

const getCourseAcademicDetails = function* (data) {
  const { payload } = data;
  yield put({ type: authActions.CANDIDATE_TOKEN_VERIFY });
  yield delay(1000);
  const candidateid = yield select(
    (state) => state?.authReducer?.candidateTokenDetails?.candidateid
  );
  try {
    const result = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_URL}/candidate/course/registraton/academic-details/${encodeURIComponent(
          EncryptFunction(candidateid)
        )}/${encodeURIComponent(EncryptFunction(payload.courseid))}`
      )
    );
    const decryptedData = yield call(handleDecodeJSON, {
      decodeJSON: result?.data?.result,
    });
    yield put({
      type: candidatesActions.SET_COURSE_ACADEMIC_DETAILS,
      payload: result?.data?.statusCode === 200 ? decryptedData : [],
    });
  } catch (err) {}
};


const handleGetInstructionRead = function* (data){
   const { payload } = data;
   try {
        const result = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_URL}/candidate/course/registraton/instruction-read-status/${encodeURIComponent(
          EncryptFunction(payload?.data?.candidateid)
        )}/${encodeURIComponent(EncryptFunction(payload?.data?.courseid))}`
      )
    );
    // console.log(result,"resulr cosneodddddd")
    const decryptedData = yield call(handleDecodeJSON, {
      decodeJSON: result?.data?.result,
    });
     yield put({
       type: candidatesActions.SET_IS_INSTRUCTION_READ,
       payload: result?.data?.statusCode === 200 ? decryptedData : [],
       courseId: payload?.data?.courseid,
     });
   } catch (error) {
    
   }
   
}

const handleInstructionRead = function* (data){
  const { payload } = data;
  const { navigate} = payload?.data;
    const encodedData = yield call(handleEncodeJson, {
    encodeJSON: payload?.data,
  });

  try {
      const result = yield call(() =>
      axios.post(`${process.env.REACT_APP_API_URL}/candidate/course/registraton/instruction`, encodedData)
    );
    if (result) {
      yield put({
        type: candidatesActions.GET_IS_INSTRUCTION_READ,
        payload: {
          data: {
            courseid: payload?.data?.courseid,
            candidateid: payload?.data?.candidateid,
          },
        },
      });
      navigate(
      `/${sessionStorage.getItem(
        "mhet_cnd_project"
      )}/course-registration?page=personalinformation&courseid=${EncryptFunction(payload?.data?.courseid)}&coursename=${encodeURIComponent(
        payload?.data?.coursename
      )}`
    );
    }
  } catch (error) {
    // console.log(error,"error cosnoled")
          yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: "failed",
          show: true,
          message: error?.data?.message,
        },
      });
      yield delay(2000);
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: null,
          show: false,
          message: null,
        }
      });
  }
}


const getCourseExamCenterDetails = function* (data) {
  const { payload } = data;
  yield put({ type: authActions.CANDIDATE_TOKEN_VERIFY });
  yield delay(1000);
  const candidateid = yield select(
    (state) => state?.authReducer?.candidateTokenDetails?.candidateid
  );
  try {
    const result = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_URL}/candidate/course/registraton/examcenter-details/${encodeURIComponent(
          EncryptFunction(candidateid)
        )}/${encodeURIComponent(EncryptFunction(payload.courseid))}`
      )
    );
    const decryptedData = yield call(handleDecodeJSON, {
      decodeJSON: result?.data?.result,
    });
    yield put({
      type: candidatesActions.SET_COURSE_EXAMCENTER_DETAILS,
      payload: result?.data?.statusCode === 200 ? decryptedData : [],
    });
  } catch (err) {}
};


const getCourseEditingFacilityDetails = function* (data) {
  const { payload } = data;
  const {navigate} = payload;
  yield put({ type: authActions.CANDIDATE_TOKEN_VERIFY });
  yield delay(1000);
  const candidateid = yield select(
    (state) => state?.authReducer?.candidateTokenDetails?.candidateid
  );
  try {
    const result = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_URL}/candidate/course/registraton/editingfacility-details/${encodeURIComponent(
          EncryptFunction(candidateid)
        )}/${encodeURIComponent(EncryptFunction(payload.courseid))}`
      )
    );
    const decryptedData = yield call(handleDecodeJSON, {
      decodeJSON: result?.data?.result,
    });
    yield put({
      type: candidatesActions.SET_COURSE_EDITINGFACILITY_DETAILS,
      payload: result?.data?.statusCode === 200 ? decryptedData : [],
    });
  } catch (err) {
    if (err?.response?.data?.statusCode === 400) {
          yield put({
      type: candidatesActions.SET_COURSE_EDITINGFACILITY_DETAILS,
      payload: [],
    });
      if (
        process.env.REACT_APP_REDIRECT_TO_CLP_EDIT_WINDOW
          ?.split(",")
          .map(id => id.trim())
          .includes(String(payload?.courseid))
      ) {
        navigate(
          `/${sessionStorage.getItem(
            "mhet_cnd_project"
          )}/course-registration?page=personalinformation&courseid=${EncryptFunction(
            payload?.courseid
          )}&coursename=${encodeURIComponent(payload?.coursename)}`
        );
      } else {
        yield put({
          type: commonActions.SHOW_CLOSE_EDITING_TAB_MODAL,
          payload: true,
        });
      }
    }
  }
};


const getCoursePaymentInformationDetails = function* (data) {
  const { payload } = data;
  yield put({ type: authActions.CANDIDATE_TOKEN_VERIFY });
  yield delay(1000);
  const profileSummary = yield select(
    (state) => state?.authReducer?.ProfileSummaryDetails
  );
  const candidateid = yield select(
    (state) => state?.authReducer?.candidateTokenDetails?.candidateid
  ) || profileSummary[0]?.candidateid;
  try {
    const result = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_URL}/candidate/course/registraton/payment-information-details/${encodeURIComponent(
          EncryptFunction(candidateid)
        )}/${encodeURIComponent(EncryptFunction(payload?.courseid))}?edit=${payload?.edit}`
      )
    );
    const decryptedData = yield call(handleDecodeJSON, {
      decodeJSON: result?.data?.result,
    });
    yield put({
      type: candidatesActions.SET_COURSE_PAYMENTINFORMATION_DETAILS,
      payload: result?.data?.statusCode === 200 ? decryptedData : [],
    });
  } catch (err) {}
};

export default candidatesSaga;
